module.exports = [
	{
		"clip_id": "fe2d6fe3-cfae-4af2-9664-3fc5b79ea5f5",
		"scene_lqip": "https://s3.amazonaws.com/storytape-prod-static/scene_082cb041-2ef6-45c5-bbb3-4bbefe5e4ed4/lqip_8607c75f-9f4f-4428-b3e0-a21c59b06fec.jpg",
		"scene_clip_count": "40",
		"published_at": "2017-10-30T20:27:49.268Z",
		"clip_sequence": [
			"https://s3.amazonaws.com/storytape-prod-static/fe2d6fe3-cfae-4af2-9664-3fc5b79ea5f5/sequence_2ee48e83-7e71-428a-ac8f-bf7aeda91a9f/0000.png",
			"https://s3.amazonaws.com/storytape-prod-static/fe2d6fe3-cfae-4af2-9664-3fc5b79ea5f5/sequence_2ee48e83-7e71-428a-ac8f-bf7aeda91a9f/0001.png",
			"https://s3.amazonaws.com/storytape-prod-static/fe2d6fe3-cfae-4af2-9664-3fc5b79ea5f5/sequence_2ee48e83-7e71-428a-ac8f-bf7aeda91a9f/0002.png",
			"https://s3.amazonaws.com/storytape-prod-static/fe2d6fe3-cfae-4af2-9664-3fc5b79ea5f5/sequence_2ee48e83-7e71-428a-ac8f-bf7aeda91a9f/0003.png",
			"https://s3.amazonaws.com/storytape-prod-static/fe2d6fe3-cfae-4af2-9664-3fc5b79ea5f5/sequence_2ee48e83-7e71-428a-ac8f-bf7aeda91a9f/0004.png",
			"https://s3.amazonaws.com/storytape-prod-static/fe2d6fe3-cfae-4af2-9664-3fc5b79ea5f5/sequence_2ee48e83-7e71-428a-ac8f-bf7aeda91a9f/0005.png",
			"https://s3.amazonaws.com/storytape-prod-static/fe2d6fe3-cfae-4af2-9664-3fc5b79ea5f5/sequence_2ee48e83-7e71-428a-ac8f-bf7aeda91a9f/0006.png",
			"https://s3.amazonaws.com/storytape-prod-static/fe2d6fe3-cfae-4af2-9664-3fc5b79ea5f5/sequence_2ee48e83-7e71-428a-ac8f-bf7aeda91a9f/0007.png",
			"https://s3.amazonaws.com/storytape-prod-static/fe2d6fe3-cfae-4af2-9664-3fc5b79ea5f5/sequence_2ee48e83-7e71-428a-ac8f-bf7aeda91a9f/0008.png",
			"https://s3.amazonaws.com/storytape-prod-static/fe2d6fe3-cfae-4af2-9664-3fc5b79ea5f5/sequence_2ee48e83-7e71-428a-ac8f-bf7aeda91a9f/0009.png",
			"https://s3.amazonaws.com/storytape-prod-static/fe2d6fe3-cfae-4af2-9664-3fc5b79ea5f5/sequence_2ee48e83-7e71-428a-ac8f-bf7aeda91a9f/0010.png",
			"https://s3.amazonaws.com/storytape-prod-static/fe2d6fe3-cfae-4af2-9664-3fc5b79ea5f5/sequence_2ee48e83-7e71-428a-ac8f-bf7aeda91a9f/0011.png",
			"https://s3.amazonaws.com/storytape-prod-static/fe2d6fe3-cfae-4af2-9664-3fc5b79ea5f5/sequence_2ee48e83-7e71-428a-ac8f-bf7aeda91a9f/0012.png",
			"https://s3.amazonaws.com/storytape-prod-static/fe2d6fe3-cfae-4af2-9664-3fc5b79ea5f5/sequence_2ee48e83-7e71-428a-ac8f-bf7aeda91a9f/0013.png",
			"https://s3.amazonaws.com/storytape-prod-static/fe2d6fe3-cfae-4af2-9664-3fc5b79ea5f5/sequence_2ee48e83-7e71-428a-ac8f-bf7aeda91a9f/0014.png",
			"https://s3.amazonaws.com/storytape-prod-static/fe2d6fe3-cfae-4af2-9664-3fc5b79ea5f5/sequence_2ee48e83-7e71-428a-ac8f-bf7aeda91a9f/0015.png",
			"https://s3.amazonaws.com/storytape-prod-static/fe2d6fe3-cfae-4af2-9664-3fc5b79ea5f5/sequence_2ee48e83-7e71-428a-ac8f-bf7aeda91a9f/0016.png",
			"https://s3.amazonaws.com/storytape-prod-static/fe2d6fe3-cfae-4af2-9664-3fc5b79ea5f5/sequence_2ee48e83-7e71-428a-ac8f-bf7aeda91a9f/0017.png",
			"https://s3.amazonaws.com/storytape-prod-static/fe2d6fe3-cfae-4af2-9664-3fc5b79ea5f5/sequence_2ee48e83-7e71-428a-ac8f-bf7aeda91a9f/0018.png",
			"https://s3.amazonaws.com/storytape-prod-static/fe2d6fe3-cfae-4af2-9664-3fc5b79ea5f5/sequence_2ee48e83-7e71-428a-ac8f-bf7aeda91a9f/0019.png",
			"https://s3.amazonaws.com/storytape-prod-static/fe2d6fe3-cfae-4af2-9664-3fc5b79ea5f5/sequence_2ee48e83-7e71-428a-ac8f-bf7aeda91a9f/0020.png",
			"https://s3.amazonaws.com/storytape-prod-static/fe2d6fe3-cfae-4af2-9664-3fc5b79ea5f5/sequence_2ee48e83-7e71-428a-ac8f-bf7aeda91a9f/0021.png",
			"https://s3.amazonaws.com/storytape-prod-static/fe2d6fe3-cfae-4af2-9664-3fc5b79ea5f5/sequence_2ee48e83-7e71-428a-ac8f-bf7aeda91a9f/0022.png",
			"https://s3.amazonaws.com/storytape-prod-static/fe2d6fe3-cfae-4af2-9664-3fc5b79ea5f5/sequence_2ee48e83-7e71-428a-ac8f-bf7aeda91a9f/0023.png",
			"https://s3.amazonaws.com/storytape-prod-static/fe2d6fe3-cfae-4af2-9664-3fc5b79ea5f5/sequence_2ee48e83-7e71-428a-ac8f-bf7aeda91a9f/0024.png",
			"https://s3.amazonaws.com/storytape-prod-static/fe2d6fe3-cfae-4af2-9664-3fc5b79ea5f5/sequence_2ee48e83-7e71-428a-ac8f-bf7aeda91a9f/0025.png",
			"https://s3.amazonaws.com/storytape-prod-static/fe2d6fe3-cfae-4af2-9664-3fc5b79ea5f5/sequence_2ee48e83-7e71-428a-ac8f-bf7aeda91a9f/0026.png",
			"https://s3.amazonaws.com/storytape-prod-static/fe2d6fe3-cfae-4af2-9664-3fc5b79ea5f5/sequence_2ee48e83-7e71-428a-ac8f-bf7aeda91a9f/0027.png",
			"https://s3.amazonaws.com/storytape-prod-static/fe2d6fe3-cfae-4af2-9664-3fc5b79ea5f5/sequence_2ee48e83-7e71-428a-ac8f-bf7aeda91a9f/0028.png",
			"https://s3.amazonaws.com/storytape-prod-static/fe2d6fe3-cfae-4af2-9664-3fc5b79ea5f5/sequence_2ee48e83-7e71-428a-ac8f-bf7aeda91a9f/0029.png",
			"https://s3.amazonaws.com/storytape-prod-static/fe2d6fe3-cfae-4af2-9664-3fc5b79ea5f5/sequence_2ee48e83-7e71-428a-ac8f-bf7aeda91a9f/0030.png",
			"https://s3.amazonaws.com/storytape-prod-static/fe2d6fe3-cfae-4af2-9664-3fc5b79ea5f5/sequence_2ee48e83-7e71-428a-ac8f-bf7aeda91a9f/0031.png",
			"https://s3.amazonaws.com/storytape-prod-static/fe2d6fe3-cfae-4af2-9664-3fc5b79ea5f5/sequence_2ee48e83-7e71-428a-ac8f-bf7aeda91a9f/0032.png",
			"https://s3.amazonaws.com/storytape-prod-static/fe2d6fe3-cfae-4af2-9664-3fc5b79ea5f5/sequence_2ee48e83-7e71-428a-ac8f-bf7aeda91a9f/0033.png",
			"https://s3.amazonaws.com/storytape-prod-static/fe2d6fe3-cfae-4af2-9664-3fc5b79ea5f5/sequence_2ee48e83-7e71-428a-ac8f-bf7aeda91a9f/0034.png",
			"https://s3.amazonaws.com/storytape-prod-static/fe2d6fe3-cfae-4af2-9664-3fc5b79ea5f5/sequence_2ee48e83-7e71-428a-ac8f-bf7aeda91a9f/0035.png",
			"https://s3.amazonaws.com/storytape-prod-static/fe2d6fe3-cfae-4af2-9664-3fc5b79ea5f5/sequence_2ee48e83-7e71-428a-ac8f-bf7aeda91a9f/0036.png",
			"https://s3.amazonaws.com/storytape-prod-static/fe2d6fe3-cfae-4af2-9664-3fc5b79ea5f5/sequence_2ee48e83-7e71-428a-ac8f-bf7aeda91a9f/0037.png",
			"https://s3.amazonaws.com/storytape-prod-static/fe2d6fe3-cfae-4af2-9664-3fc5b79ea5f5/sequence_2ee48e83-7e71-428a-ac8f-bf7aeda91a9f/0038.png",
			"https://s3.amazonaws.com/storytape-prod-static/fe2d6fe3-cfae-4af2-9664-3fc5b79ea5f5/sequence_2ee48e83-7e71-428a-ac8f-bf7aeda91a9f/0039.png",
			"https://s3.amazonaws.com/storytape-prod-static/fe2d6fe3-cfae-4af2-9664-3fc5b79ea5f5/sequence_2ee48e83-7e71-428a-ac8f-bf7aeda91a9f/0040.png"
		],
		"keywords": [
			"beach",
			"blacksand",
			"cloudy",
			"coast",
			"coastline",
			"crashing",
			"darken",
			"dusk",
			"evening",
			"green",
			"highlands",
			"iceland",
			"icelandic",
			"laugavegur",
			"lava",
			"lava fields",
			"lichen",
			"moss",
			"mountain landscape",
			"mountains",
			"nature",
			"ocean",
			"path",
			"peak",
			"road",
			"rock",
			"sand",
			"scenery",
			"scenic",
			"summer",
			"tourism",
			"travel",
			"volcanic",
			"volcano",
			"waves"
		],
		"clip_slug": "water-slowly-reaches-the-shore",
		"clip_poster": "https://s3.amazonaws.com/storytape-prod-static/fe2d6fe3-cfae-4af2-9664-3fc5b79ea5f5/poster_0000_ef89cf86-8c8e-4b23-8a52-c81f13550766.png",
		"clip_preview_large": "https://s3.amazonaws.com/storytape-prod-static/fe2d6fe3-cfae-4af2-9664-3fc5b79ea5f5/preview-large-53578e92-de82-4a5a-96d4-7c80758c8b18.mp4",
		"clip_length": 20000,
		"scene_description": "A unique beach with black sand covers the coast of an Icelandic shore. The waves from the ocean creates squiggly designs in the sand, where patches of grass thrive under the setting sun.",
		"clip_thumbnail": "https://s3.amazonaws.com/storytape-prod-static/fe2d6fe3-cfae-4af2-9664-3fc5b79ea5f5/thumbnail_0000_3a1d7b98-8632-453f-b708-46a4daf2a8c9.png",
		"clip_name": "Water slowly reaches the shore",
		"scene_thumbnail": "https://s3.amazonaws.com/storytape-prod-static/scene_082cb041-2ef6-45c5-bbb3-4bbefe5e4ed4/thumbnail_b13a2893-4411-4cd1-8f5d-37a5fdedadda.jpg",
		"clip_preview_small": "https://s3.amazonaws.com/storytape-prod-static/fe2d6fe3-cfae-4af2-9664-3fc5b79ea5f5/preview-small-2c9a30e6-f646-4e3f-99e5-b88238e7c586.mp4",
		"tags": [
			2900,
			2700,
			2400,
			2200,
			2100,
			1600,
			4400,
			1100,
			4200,
			900,
			3600,
			200,
			3400
		],
		"featured_at": "2017-11-14T07:12:23.643Z",
		"clip_lqip": "https://s3.amazonaws.com/storytape-prod-static/scene_fe2d6fe3-cfae-4af2-9664-3fc5b79ea5f5/lqip_fa01c79a-0ea9-455d-bcf7-f8466b1daa4d.jpg",
		"scene_poster": "https://s3.amazonaws.com/storytape-prod-static/scene_082cb041-2ef6-45c5-bbb3-4bbefe5e4ed4/poster_3f7b7d15-deab-4624-b664-f3c00451b160.jpg",
		"scene_slug": "black-sand-beach",
		"clip_colors": {
			"Vibrant": "#1895e6",
			"DarkVibrant": "#041825",
			"Muted": "#5c6171",
			"LightMuted": "#a8adc4",
			"DarkMuted": "#404758"
		},
		"scene_colors": {
			"Vibrant": "#1470ea",
			"DarkVibrant": "#04162e",
			"Muted": "#7685a5",
			"LightMuted": "#a8b3d0",
			"DarkMuted": "#364361"
		},
		"scene_name": "Black Sand Beach",
		"scene_id": "082cb041-2ef6-45c5-bbb3-4bbefe5e4ed4"
	},
	{
		"clip_id": "ff28ef7a-9167-4b92-85c6-72fb16e39c1b",
		"scene_lqip": "https://s3.amazonaws.com/storytape-prod-static/scene_a2ab422a-f5c1-45ee-ad22-572817d81d10/lqip_d2b3a0a1-9e98-4106-80c8-45d3376e6331.jpg",
		"scene_clip_count": "20",
		"published_at": "2017-11-07T17:10:01.36Z",
		"clip_sequence": [
			"https://s3.amazonaws.com/storytape-prod-static/ff28ef7a-9167-4b92-85c6-72fb16e39c1b/sequence_b3c89363-15ad-481a-a6a8-6bcfd73bba05/0000.png",
			"https://s3.amazonaws.com/storytape-prod-static/ff28ef7a-9167-4b92-85c6-72fb16e39c1b/sequence_b3c89363-15ad-481a-a6a8-6bcfd73bba05/0001.png",
			"https://s3.amazonaws.com/storytape-prod-static/ff28ef7a-9167-4b92-85c6-72fb16e39c1b/sequence_b3c89363-15ad-481a-a6a8-6bcfd73bba05/0002.png",
			"https://s3.amazonaws.com/storytape-prod-static/ff28ef7a-9167-4b92-85c6-72fb16e39c1b/sequence_b3c89363-15ad-481a-a6a8-6bcfd73bba05/0003.png",
			"https://s3.amazonaws.com/storytape-prod-static/ff28ef7a-9167-4b92-85c6-72fb16e39c1b/sequence_b3c89363-15ad-481a-a6a8-6bcfd73bba05/0004.png",
			"https://s3.amazonaws.com/storytape-prod-static/ff28ef7a-9167-4b92-85c6-72fb16e39c1b/sequence_b3c89363-15ad-481a-a6a8-6bcfd73bba05/0005.png",
			"https://s3.amazonaws.com/storytape-prod-static/ff28ef7a-9167-4b92-85c6-72fb16e39c1b/sequence_b3c89363-15ad-481a-a6a8-6bcfd73bba05/0006.png",
			"https://s3.amazonaws.com/storytape-prod-static/ff28ef7a-9167-4b92-85c6-72fb16e39c1b/sequence_b3c89363-15ad-481a-a6a8-6bcfd73bba05/0007.png",
			"https://s3.amazonaws.com/storytape-prod-static/ff28ef7a-9167-4b92-85c6-72fb16e39c1b/sequence_b3c89363-15ad-481a-a6a8-6bcfd73bba05/0008.png",
			"https://s3.amazonaws.com/storytape-prod-static/ff28ef7a-9167-4b92-85c6-72fb16e39c1b/sequence_b3c89363-15ad-481a-a6a8-6bcfd73bba05/0009.png",
			"https://s3.amazonaws.com/storytape-prod-static/ff28ef7a-9167-4b92-85c6-72fb16e39c1b/sequence_b3c89363-15ad-481a-a6a8-6bcfd73bba05/0010.png",
			"https://s3.amazonaws.com/storytape-prod-static/ff28ef7a-9167-4b92-85c6-72fb16e39c1b/sequence_b3c89363-15ad-481a-a6a8-6bcfd73bba05/0011.png",
			"https://s3.amazonaws.com/storytape-prod-static/ff28ef7a-9167-4b92-85c6-72fb16e39c1b/sequence_b3c89363-15ad-481a-a6a8-6bcfd73bba05/0012.png",
			"https://s3.amazonaws.com/storytape-prod-static/ff28ef7a-9167-4b92-85c6-72fb16e39c1b/sequence_b3c89363-15ad-481a-a6a8-6bcfd73bba05/0013.png",
			"https://s3.amazonaws.com/storytape-prod-static/ff28ef7a-9167-4b92-85c6-72fb16e39c1b/sequence_b3c89363-15ad-481a-a6a8-6bcfd73bba05/0014.png",
			"https://s3.amazonaws.com/storytape-prod-static/ff28ef7a-9167-4b92-85c6-72fb16e39c1b/sequence_b3c89363-15ad-481a-a6a8-6bcfd73bba05/0015.png",
			"https://s3.amazonaws.com/storytape-prod-static/ff28ef7a-9167-4b92-85c6-72fb16e39c1b/sequence_b3c89363-15ad-481a-a6a8-6bcfd73bba05/0016.png",
			"https://s3.amazonaws.com/storytape-prod-static/ff28ef7a-9167-4b92-85c6-72fb16e39c1b/sequence_b3c89363-15ad-481a-a6a8-6bcfd73bba05/0017.png",
			"https://s3.amazonaws.com/storytape-prod-static/ff28ef7a-9167-4b92-85c6-72fb16e39c1b/sequence_b3c89363-15ad-481a-a6a8-6bcfd73bba05/0018.png",
			"https://s3.amazonaws.com/storytape-prod-static/ff28ef7a-9167-4b92-85c6-72fb16e39c1b/sequence_b3c89363-15ad-481a-a6a8-6bcfd73bba05/0019.png",
			"https://s3.amazonaws.com/storytape-prod-static/ff28ef7a-9167-4b92-85c6-72fb16e39c1b/sequence_b3c89363-15ad-481a-a6a8-6bcfd73bba05/0020.png",
			"https://s3.amazonaws.com/storytape-prod-static/ff28ef7a-9167-4b92-85c6-72fb16e39c1b/sequence_b3c89363-15ad-481a-a6a8-6bcfd73bba05/0021.png",
			"https://s3.amazonaws.com/storytape-prod-static/ff28ef7a-9167-4b92-85c6-72fb16e39c1b/sequence_b3c89363-15ad-481a-a6a8-6bcfd73bba05/0022.png",
			"https://s3.amazonaws.com/storytape-prod-static/ff28ef7a-9167-4b92-85c6-72fb16e39c1b/sequence_b3c89363-15ad-481a-a6a8-6bcfd73bba05/0023.png",
			"https://s3.amazonaws.com/storytape-prod-static/ff28ef7a-9167-4b92-85c6-72fb16e39c1b/sequence_b3c89363-15ad-481a-a6a8-6bcfd73bba05/0024.png",
			"https://s3.amazonaws.com/storytape-prod-static/ff28ef7a-9167-4b92-85c6-72fb16e39c1b/sequence_b3c89363-15ad-481a-a6a8-6bcfd73bba05/0025.png",
			"https://s3.amazonaws.com/storytape-prod-static/ff28ef7a-9167-4b92-85c6-72fb16e39c1b/sequence_b3c89363-15ad-481a-a6a8-6bcfd73bba05/0026.png",
			"https://s3.amazonaws.com/storytape-prod-static/ff28ef7a-9167-4b92-85c6-72fb16e39c1b/sequence_b3c89363-15ad-481a-a6a8-6bcfd73bba05/0027.png",
			"https://s3.amazonaws.com/storytape-prod-static/ff28ef7a-9167-4b92-85c6-72fb16e39c1b/sequence_b3c89363-15ad-481a-a6a8-6bcfd73bba05/0028.png",
			"https://s3.amazonaws.com/storytape-prod-static/ff28ef7a-9167-4b92-85c6-72fb16e39c1b/sequence_b3c89363-15ad-481a-a6a8-6bcfd73bba05/0029.png",
			"https://s3.amazonaws.com/storytape-prod-static/ff28ef7a-9167-4b92-85c6-72fb16e39c1b/sequence_b3c89363-15ad-481a-a6a8-6bcfd73bba05/0030.png",
			"https://s3.amazonaws.com/storytape-prod-static/ff28ef7a-9167-4b92-85c6-72fb16e39c1b/sequence_b3c89363-15ad-481a-a6a8-6bcfd73bba05/0031.png"
		],
		"keywords": [
			"adult",
			"background",
			"beach",
			"beautiful",
			"blue",
			"calm",
			"cloud",
			"coastline",
			"color",
			"colorful",
			"dawn",
			"dusk",
			"evening",
			"horizon",
			"landscape",
			"long hair",
			"man",
			"morning",
			"nature",
			"ocean",
			"orange",
			"outdoor",
			"red",
			"reflection",
			"romantic",
			"scene",
			"scenic",
			"sea",
			"seascape",
			"sky",
			"sun",
			"sunlight",
			"sunny",
			"sunrise",
			"sunset",
			"sunshine",
			"tranquil",
			"vacation",
			"watching",
			"water",
			"wave",
			"yellow"
		],
		"clip_slug": "long-haired-man-taking-in-still-sunrise",
		"clip_poster": "https://s3.amazonaws.com/storytape-prod-static/ff28ef7a-9167-4b92-85c6-72fb16e39c1b/poster_0000_e1201134-5e1e-43f1-aa60-5440f30c0e30.png",
		"clip_preview_large": "https://s3.amazonaws.com/storytape-prod-static/ff28ef7a-9167-4b92-85c6-72fb16e39c1b/preview-large-122f231c-7515-43f1-96d5-871aa06fce70.mp4",
		"clip_length": 15958,
		"scene_description": "A young man with long hair waits by a lakefront for the sun to rise. The early dawn brings unique lighting to evoke a dramatic look on his facial features, hands, and feet.",
		"clip_thumbnail": "https://s3.amazonaws.com/storytape-prod-static/ff28ef7a-9167-4b92-85c6-72fb16e39c1b/thumbnail_0000_7f6b983a-08c7-4c4e-a1e0-405aeec31705.png",
		"clip_name": "Long-haired man taking in still sunrise",
		"scene_thumbnail": "https://s3.amazonaws.com/storytape-prod-static/scene_a2ab422a-f5c1-45ee-ad22-572817d81d10/thumbnail_201cabed-3a94-45af-beb2-ba1e5c60b3ed.jpg",
		"clip_preview_small": "https://s3.amazonaws.com/storytape-prod-static/ff28ef7a-9167-4b92-85c6-72fb16e39c1b/preview-small-7ef3510f-7b21-4bf8-9765-193bbd5b1dc3.mp4",
		"tags": [
			2900,
			1200,
			1100,
			2700,
			4300,
			2300,
			2200,
			2100,
			3700,
			4000,
			100,
			3200
		],
		"clip_lqip": "https://s3.amazonaws.com/storytape-prod-static/scene_ff28ef7a-9167-4b92-85c6-72fb16e39c1b/lqip_f6c26376-8618-40e8-94dc-e6ca49dc5675.jpg",
		"scene_poster": "https://s3.amazonaws.com/storytape-prod-static/scene_a2ab422a-f5c1-45ee-ad22-572817d81d10/poster_b6920871-0f45-4d22-ac74-d810b5444a80.jpg",
		"scene_slug": "hands-and-feet",
		"clip_colors": {
			"Vibrant": "#c89c88",
			"DarkVibrant": "#0c131c",
			"Muted": "#6c7281",
			"LightMuted": "#b2b4ba",
			"DarkMuted": "#2d3946"
		},
		"scene_colors": {
			"Vibrant": "#4c8cb2",
			"DarkVibrant": "#244254",
			"Muted": "#495c74",
			"DarkMuted": "#2f3454"
		},
		"scene_name": "Hands And Feet",
		"scene_id": "a2ab422a-f5c1-45ee-ad22-572817d81d10"
	},
	{
		"clip_id": "fcd9f26d-5c84-42ff-8354-e9a83184b620",
		"scene_lqip": "https://s3.amazonaws.com/storytape-prod-static/scene_a539ded5-5f45-44aa-85c3-6c7f9cc28952/lqip_507f5f17-b73e-479b-9396-f582c7825c79.jpg",
		"scene_clip_count": "76",
		"published_at": "2017-10-27T15:59:52.047Z",
		"clip_sequence": [
			"https://s3.amazonaws.com/storytape-prod-static/fcd9f26d-5c84-42ff-8354-e9a83184b620/sequence_b9d7aec2-4a21-42cb-b864-55bc25bd594f/0000.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcd9f26d-5c84-42ff-8354-e9a83184b620/sequence_b9d7aec2-4a21-42cb-b864-55bc25bd594f/0001.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcd9f26d-5c84-42ff-8354-e9a83184b620/sequence_b9d7aec2-4a21-42cb-b864-55bc25bd594f/0002.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcd9f26d-5c84-42ff-8354-e9a83184b620/sequence_b9d7aec2-4a21-42cb-b864-55bc25bd594f/0003.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcd9f26d-5c84-42ff-8354-e9a83184b620/sequence_b9d7aec2-4a21-42cb-b864-55bc25bd594f/0004.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcd9f26d-5c84-42ff-8354-e9a83184b620/sequence_b9d7aec2-4a21-42cb-b864-55bc25bd594f/0005.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcd9f26d-5c84-42ff-8354-e9a83184b620/sequence_b9d7aec2-4a21-42cb-b864-55bc25bd594f/0006.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcd9f26d-5c84-42ff-8354-e9a83184b620/sequence_b9d7aec2-4a21-42cb-b864-55bc25bd594f/0007.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcd9f26d-5c84-42ff-8354-e9a83184b620/sequence_b9d7aec2-4a21-42cb-b864-55bc25bd594f/0008.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcd9f26d-5c84-42ff-8354-e9a83184b620/sequence_b9d7aec2-4a21-42cb-b864-55bc25bd594f/0009.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcd9f26d-5c84-42ff-8354-e9a83184b620/sequence_b9d7aec2-4a21-42cb-b864-55bc25bd594f/0010.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcd9f26d-5c84-42ff-8354-e9a83184b620/sequence_b9d7aec2-4a21-42cb-b864-55bc25bd594f/0011.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcd9f26d-5c84-42ff-8354-e9a83184b620/sequence_b9d7aec2-4a21-42cb-b864-55bc25bd594f/0012.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcd9f26d-5c84-42ff-8354-e9a83184b620/sequence_b9d7aec2-4a21-42cb-b864-55bc25bd594f/0013.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcd9f26d-5c84-42ff-8354-e9a83184b620/sequence_b9d7aec2-4a21-42cb-b864-55bc25bd594f/0014.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcd9f26d-5c84-42ff-8354-e9a83184b620/sequence_b9d7aec2-4a21-42cb-b864-55bc25bd594f/0015.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcd9f26d-5c84-42ff-8354-e9a83184b620/sequence_b9d7aec2-4a21-42cb-b864-55bc25bd594f/0016.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcd9f26d-5c84-42ff-8354-e9a83184b620/sequence_b9d7aec2-4a21-42cb-b864-55bc25bd594f/0017.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcd9f26d-5c84-42ff-8354-e9a83184b620/sequence_b9d7aec2-4a21-42cb-b864-55bc25bd594f/0018.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcd9f26d-5c84-42ff-8354-e9a83184b620/sequence_b9d7aec2-4a21-42cb-b864-55bc25bd594f/0019.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcd9f26d-5c84-42ff-8354-e9a83184b620/sequence_b9d7aec2-4a21-42cb-b864-55bc25bd594f/0020.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcd9f26d-5c84-42ff-8354-e9a83184b620/sequence_b9d7aec2-4a21-42cb-b864-55bc25bd594f/0021.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcd9f26d-5c84-42ff-8354-e9a83184b620/sequence_b9d7aec2-4a21-42cb-b864-55bc25bd594f/0022.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcd9f26d-5c84-42ff-8354-e9a83184b620/sequence_b9d7aec2-4a21-42cb-b864-55bc25bd594f/0023.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcd9f26d-5c84-42ff-8354-e9a83184b620/sequence_b9d7aec2-4a21-42cb-b864-55bc25bd594f/0024.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcd9f26d-5c84-42ff-8354-e9a83184b620/sequence_b9d7aec2-4a21-42cb-b864-55bc25bd594f/0025.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcd9f26d-5c84-42ff-8354-e9a83184b620/sequence_b9d7aec2-4a21-42cb-b864-55bc25bd594f/0026.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcd9f26d-5c84-42ff-8354-e9a83184b620/sequence_b9d7aec2-4a21-42cb-b864-55bc25bd594f/0027.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcd9f26d-5c84-42ff-8354-e9a83184b620/sequence_b9d7aec2-4a21-42cb-b864-55bc25bd594f/0028.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcd9f26d-5c84-42ff-8354-e9a83184b620/sequence_b9d7aec2-4a21-42cb-b864-55bc25bd594f/0029.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcd9f26d-5c84-42ff-8354-e9a83184b620/sequence_b9d7aec2-4a21-42cb-b864-55bc25bd594f/0030.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcd9f26d-5c84-42ff-8354-e9a83184b620/sequence_b9d7aec2-4a21-42cb-b864-55bc25bd594f/0031.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcd9f26d-5c84-42ff-8354-e9a83184b620/sequence_b9d7aec2-4a21-42cb-b864-55bc25bd594f/0032.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcd9f26d-5c84-42ff-8354-e9a83184b620/sequence_b9d7aec2-4a21-42cb-b864-55bc25bd594f/0033.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcd9f26d-5c84-42ff-8354-e9a83184b620/sequence_b9d7aec2-4a21-42cb-b864-55bc25bd594f/0034.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcd9f26d-5c84-42ff-8354-e9a83184b620/sequence_b9d7aec2-4a21-42cb-b864-55bc25bd594f/0035.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcd9f26d-5c84-42ff-8354-e9a83184b620/sequence_b9d7aec2-4a21-42cb-b864-55bc25bd594f/0036.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcd9f26d-5c84-42ff-8354-e9a83184b620/sequence_b9d7aec2-4a21-42cb-b864-55bc25bd594f/0037.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcd9f26d-5c84-42ff-8354-e9a83184b620/sequence_b9d7aec2-4a21-42cb-b864-55bc25bd594f/0038.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcd9f26d-5c84-42ff-8354-e9a83184b620/sequence_b9d7aec2-4a21-42cb-b864-55bc25bd594f/0039.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcd9f26d-5c84-42ff-8354-e9a83184b620/sequence_b9d7aec2-4a21-42cb-b864-55bc25bd594f/0040.png"
		],
		"keywords": [
			"abstract",
			"acrylic",
			"art",
			"artistic",
			"background",
			"bubble",
			"close-up",
			"color",
			"colorful",
			"colour",
			"colourful",
			"design",
			"droplet",
			"dye",
			"flow",
			"fluidity",
			"glitter",
			"grunge",
			"ink",
			"liquid",
			"macro",
			"microscope",
			"mix",
			"mixture",
			"multi-colored",
			"neon",
			"oil",
			"paint",
			"pattern",
			"psychedelic",
			"rainbow",
			"ripple",
			"saturated",
			"texture",
			"wallpaper",
			"wet"
		],
		"clip_slug": "sparkles-appear-in-neon-green-paint-circle",
		"clip_poster": "https://s3.amazonaws.com/storytape-prod-static/fcd9f26d-5c84-42ff-8354-e9a83184b620/poster_0000_664d3e03-9383-4993-9cf7-7a8545c342a5.png",
		"clip_preview_large": "https://s3.amazonaws.com/storytape-prod-static/fcd9f26d-5c84-42ff-8354-e9a83184b620/preview-large-684db6c9-761a-4c88-85c3-b615e2843b25.mp4",
		"clip_length": 20000,
		"scene_description": "Experimental and mesmerizing abstract visuals of acrylic paint swirling in milk, water, and oil. Various neon colors, some with glitter and metallic finishes, give each color its own unique texture.",
		"clip_thumbnail": "https://s3.amazonaws.com/storytape-prod-static/fcd9f26d-5c84-42ff-8354-e9a83184b620/thumbnail_0000_1c2fb9ee-5be4-4e74-8645-81ff3a96ad99.png",
		"clip_name": "Sparkles appear in neon green paint circle",
		"scene_thumbnail": "https://s3.amazonaws.com/storytape-prod-static/scene_a539ded5-5f45-44aa-85c3-6c7f9cc28952/thumbnail_7fdac6c9-54c6-4414-b394-809bdbb6c812.jpg",
		"clip_preview_small": "https://s3.amazonaws.com/storytape-prod-static/fcd9f26d-5c84-42ff-8354-e9a83184b620/preview-small-4fa41407-0878-4a84-afb1-db45fd469ee2.mp4",
		"tags": [
			4300,
			2300,
			3900,
			2100,
			4000,
			1800,
			100
		],
		"featured_at": "2017-11-14T07:11:51.209Z",
		"clip_lqip": "https://s3.amazonaws.com/storytape-prod-static/scene_fcd9f26d-5c84-42ff-8354-e9a83184b620/lqip_70806926-f43c-4ff6-b072-f535711d9953.jpg",
		"scene_poster": "https://s3.amazonaws.com/storytape-prod-static/scene_a539ded5-5f45-44aa-85c3-6c7f9cc28952/poster_3da94441-2462-4723-a523-a2ba4d23fd77.jpg",
		"scene_slug": "swirling-colors",
		"clip_colors": {
			"Vibrant": "#b4cc7c",
			"LightVibrant": "#b4dc8c",
			"DarkVibrant": "#797534",
			"Muted": "#acc177",
			"LightMuted": "#c8acad",
			"DarkMuted": "#8c8b4a"
		},
		"scene_colors": {
			"Vibrant": "#caad52",
			"LightVibrant": "#de7baa",
			"DarkVibrant": "#7f2350",
			"Muted": "#a7aa5d",
			"LightMuted": "#d7a7bf",
			"DarkMuted": "#4e5052"
		},
		"scene_name": "Swirling Colors",
		"scene_id": "a539ded5-5f45-44aa-85c3-6c7f9cc28952"
	},
	{
		"clip_id": "f2d70040-badd-425b-9eb1-35aba491dc0e",
		"scene_lqip": "https://s3.amazonaws.com/storytape-prod-static/scene_b65bd153-a225-4ed3-9740-e994af5e64c8/lqip_716dc8f8-b040-4e13-92d6-fcc5701bd498.jpg",
		"scene_clip_count": "30",
		"published_at": "2017-10-30T15:22:39.538Z",
		"clip_sequence": [
			"https://s3.amazonaws.com/storytape-prod-static/f2d70040-badd-425b-9eb1-35aba491dc0e/sequence_f9bfeb2f-1ae7-418c-84d4-4bde91e8b9fc/0000.png",
			"https://s3.amazonaws.com/storytape-prod-static/f2d70040-badd-425b-9eb1-35aba491dc0e/sequence_f9bfeb2f-1ae7-418c-84d4-4bde91e8b9fc/0001.png",
			"https://s3.amazonaws.com/storytape-prod-static/f2d70040-badd-425b-9eb1-35aba491dc0e/sequence_f9bfeb2f-1ae7-418c-84d4-4bde91e8b9fc/0002.png",
			"https://s3.amazonaws.com/storytape-prod-static/f2d70040-badd-425b-9eb1-35aba491dc0e/sequence_f9bfeb2f-1ae7-418c-84d4-4bde91e8b9fc/0003.png",
			"https://s3.amazonaws.com/storytape-prod-static/f2d70040-badd-425b-9eb1-35aba491dc0e/sequence_f9bfeb2f-1ae7-418c-84d4-4bde91e8b9fc/0004.png",
			"https://s3.amazonaws.com/storytape-prod-static/f2d70040-badd-425b-9eb1-35aba491dc0e/sequence_f9bfeb2f-1ae7-418c-84d4-4bde91e8b9fc/0005.png",
			"https://s3.amazonaws.com/storytape-prod-static/f2d70040-badd-425b-9eb1-35aba491dc0e/sequence_f9bfeb2f-1ae7-418c-84d4-4bde91e8b9fc/0006.png",
			"https://s3.amazonaws.com/storytape-prod-static/f2d70040-badd-425b-9eb1-35aba491dc0e/sequence_f9bfeb2f-1ae7-418c-84d4-4bde91e8b9fc/0007.png",
			"https://s3.amazonaws.com/storytape-prod-static/f2d70040-badd-425b-9eb1-35aba491dc0e/sequence_f9bfeb2f-1ae7-418c-84d4-4bde91e8b9fc/0008.png",
			"https://s3.amazonaws.com/storytape-prod-static/f2d70040-badd-425b-9eb1-35aba491dc0e/sequence_f9bfeb2f-1ae7-418c-84d4-4bde91e8b9fc/0009.png",
			"https://s3.amazonaws.com/storytape-prod-static/f2d70040-badd-425b-9eb1-35aba491dc0e/sequence_f9bfeb2f-1ae7-418c-84d4-4bde91e8b9fc/0010.png",
			"https://s3.amazonaws.com/storytape-prod-static/f2d70040-badd-425b-9eb1-35aba491dc0e/sequence_f9bfeb2f-1ae7-418c-84d4-4bde91e8b9fc/0011.png",
			"https://s3.amazonaws.com/storytape-prod-static/f2d70040-badd-425b-9eb1-35aba491dc0e/sequence_f9bfeb2f-1ae7-418c-84d4-4bde91e8b9fc/0012.png",
			"https://s3.amazonaws.com/storytape-prod-static/f2d70040-badd-425b-9eb1-35aba491dc0e/sequence_f9bfeb2f-1ae7-418c-84d4-4bde91e8b9fc/0013.png",
			"https://s3.amazonaws.com/storytape-prod-static/f2d70040-badd-425b-9eb1-35aba491dc0e/sequence_f9bfeb2f-1ae7-418c-84d4-4bde91e8b9fc/0014.png",
			"https://s3.amazonaws.com/storytape-prod-static/f2d70040-badd-425b-9eb1-35aba491dc0e/sequence_f9bfeb2f-1ae7-418c-84d4-4bde91e8b9fc/0015.png",
			"https://s3.amazonaws.com/storytape-prod-static/f2d70040-badd-425b-9eb1-35aba491dc0e/sequence_f9bfeb2f-1ae7-418c-84d4-4bde91e8b9fc/0016.png",
			"https://s3.amazonaws.com/storytape-prod-static/f2d70040-badd-425b-9eb1-35aba491dc0e/sequence_f9bfeb2f-1ae7-418c-84d4-4bde91e8b9fc/0017.png",
			"https://s3.amazonaws.com/storytape-prod-static/f2d70040-badd-425b-9eb1-35aba491dc0e/sequence_f9bfeb2f-1ae7-418c-84d4-4bde91e8b9fc/0018.png",
			"https://s3.amazonaws.com/storytape-prod-static/f2d70040-badd-425b-9eb1-35aba491dc0e/sequence_f9bfeb2f-1ae7-418c-84d4-4bde91e8b9fc/0019.png",
			"https://s3.amazonaws.com/storytape-prod-static/f2d70040-badd-425b-9eb1-35aba491dc0e/sequence_f9bfeb2f-1ae7-418c-84d4-4bde91e8b9fc/0020.png",
			"https://s3.amazonaws.com/storytape-prod-static/f2d70040-badd-425b-9eb1-35aba491dc0e/sequence_f9bfeb2f-1ae7-418c-84d4-4bde91e8b9fc/0021.png",
			"https://s3.amazonaws.com/storytape-prod-static/f2d70040-badd-425b-9eb1-35aba491dc0e/sequence_f9bfeb2f-1ae7-418c-84d4-4bde91e8b9fc/0022.png",
			"https://s3.amazonaws.com/storytape-prod-static/f2d70040-badd-425b-9eb1-35aba491dc0e/sequence_f9bfeb2f-1ae7-418c-84d4-4bde91e8b9fc/0023.png",
			"https://s3.amazonaws.com/storytape-prod-static/f2d70040-badd-425b-9eb1-35aba491dc0e/sequence_f9bfeb2f-1ae7-418c-84d4-4bde91e8b9fc/0024.png",
			"https://s3.amazonaws.com/storytape-prod-static/f2d70040-badd-425b-9eb1-35aba491dc0e/sequence_f9bfeb2f-1ae7-418c-84d4-4bde91e8b9fc/0025.png",
			"https://s3.amazonaws.com/storytape-prod-static/f2d70040-badd-425b-9eb1-35aba491dc0e/sequence_f9bfeb2f-1ae7-418c-84d4-4bde91e8b9fc/0026.png",
			"https://s3.amazonaws.com/storytape-prod-static/f2d70040-badd-425b-9eb1-35aba491dc0e/sequence_f9bfeb2f-1ae7-418c-84d4-4bde91e8b9fc/0027.png",
			"https://s3.amazonaws.com/storytape-prod-static/f2d70040-badd-425b-9eb1-35aba491dc0e/sequence_f9bfeb2f-1ae7-418c-84d4-4bde91e8b9fc/0028.png",
			"https://s3.amazonaws.com/storytape-prod-static/f2d70040-badd-425b-9eb1-35aba491dc0e/sequence_f9bfeb2f-1ae7-418c-84d4-4bde91e8b9fc/0029.png",
			"https://s3.amazonaws.com/storytape-prod-static/f2d70040-badd-425b-9eb1-35aba491dc0e/sequence_f9bfeb2f-1ae7-418c-84d4-4bde91e8b9fc/0030.png",
			"https://s3.amazonaws.com/storytape-prod-static/f2d70040-badd-425b-9eb1-35aba491dc0e/sequence_f9bfeb2f-1ae7-418c-84d4-4bde91e8b9fc/0031.png",
			"https://s3.amazonaws.com/storytape-prod-static/f2d70040-badd-425b-9eb1-35aba491dc0e/sequence_f9bfeb2f-1ae7-418c-84d4-4bde91e8b9fc/0032.png",
			"https://s3.amazonaws.com/storytape-prod-static/f2d70040-badd-425b-9eb1-35aba491dc0e/sequence_f9bfeb2f-1ae7-418c-84d4-4bde91e8b9fc/0033.png",
			"https://s3.amazonaws.com/storytape-prod-static/f2d70040-badd-425b-9eb1-35aba491dc0e/sequence_f9bfeb2f-1ae7-418c-84d4-4bde91e8b9fc/0034.png",
			"https://s3.amazonaws.com/storytape-prod-static/f2d70040-badd-425b-9eb1-35aba491dc0e/sequence_f9bfeb2f-1ae7-418c-84d4-4bde91e8b9fc/0035.png",
			"https://s3.amazonaws.com/storytape-prod-static/f2d70040-badd-425b-9eb1-35aba491dc0e/sequence_f9bfeb2f-1ae7-418c-84d4-4bde91e8b9fc/0036.png",
			"https://s3.amazonaws.com/storytape-prod-static/f2d70040-badd-425b-9eb1-35aba491dc0e/sequence_f9bfeb2f-1ae7-418c-84d4-4bde91e8b9fc/0037.png",
			"https://s3.amazonaws.com/storytape-prod-static/f2d70040-badd-425b-9eb1-35aba491dc0e/sequence_f9bfeb2f-1ae7-418c-84d4-4bde91e8b9fc/0038.png",
			"https://s3.amazonaws.com/storytape-prod-static/f2d70040-badd-425b-9eb1-35aba491dc0e/sequence_f9bfeb2f-1ae7-418c-84d4-4bde91e8b9fc/0039.png"
		],
		"keywords": [
			"African American",
			"business",
			"businessman",
			"communication",
			"company",
			"creativity",
			"data",
			"design",
			"development",
			"digital",
			"economy",
			"effort",
			"entrepreneur",
			"future",
			"global",
			"growth",
			"hands",
			"information",
			"laptop",
			"management",
			"project",
			"report",
			"research",
			"resource",
			"solution",
			"strategy",
			"sustainable",
			"technical",
			"technology",
			"typing",
			"using",
			"work"
		],
		"clip_slug": "bearded-man-with-glasses-scrolling-on-laptop",
		"clip_poster": "https://s3.amazonaws.com/storytape-prod-static/f2d70040-badd-425b-9eb1-35aba491dc0e/poster_0000_8791d045-e399-48fa-9418-ff63786eb5c1.png",
		"clip_preview_large": "https://s3.amazonaws.com/storytape-prod-static/f2d70040-badd-425b-9eb1-35aba491dc0e/preview-large-dd5118f4-c007-46de-9fbd-515017502eb5.mp4",
		"clip_length": 19875,
		"scene_description": "Working at a small table by himself, a young man types away at his laptop and uses his phone to keep up to date with current social media. The open-concept office space makes for the perfect workplace setting.",
		"clip_thumbnail": "https://s3.amazonaws.com/storytape-prod-static/f2d70040-badd-425b-9eb1-35aba491dc0e/thumbnail_0000_2d47a45c-d011-4230-b769-897256bf4f64.png",
		"clip_name": "Bearded man with glasses scrolling on laptop",
		"scene_thumbnail": "https://s3.amazonaws.com/storytape-prod-static/scene_b65bd153-a225-4ed3-9740-e994af5e64c8/thumbnail_2ea4a776-12c1-4792-88aa-1ebdc8628892.jpg",
		"clip_preview_small": "https://s3.amazonaws.com/storytape-prod-static/f2d70040-badd-425b-9eb1-35aba491dc0e/preview-small-b1fd95b1-d4bf-4259-a7a5-172cfe3a3a67.mp4",
		"tags": [
			1200,
			4300,
			2600,
			2300,
			3800,
			2100,
			4000,
			400,
			1000,
			1800,
			3300,
			1500
		],
		"featured_at": "2017-11-14T07:11:23.13Z",
		"clip_lqip": "https://s3.amazonaws.com/storytape-prod-static/scene_f2d70040-badd-425b-9eb1-35aba491dc0e/lqip_65665f36-7437-4334-9b5f-0bd2ae307a7f.jpg",
		"scene_poster": "https://s3.amazonaws.com/storytape-prod-static/scene_b65bd153-a225-4ed3-9740-e994af5e64c8/poster_798291ad-18d2-491b-a428-ded2e23d70f3.jpg",
		"scene_slug": "laptop-at-table",
		"clip_colors": {
			"Vibrant": "#34547c",
			"DarkVibrant": "#243f5d",
			"Muted": "#78847f",
			"LightMuted": "#c4cfc7",
			"DarkMuted": "#433b3a"
		},
		"scene_colors": {
			"Vibrant": "#219871",
			"DarkVibrant": "#1c6444",
			"Muted": "#758884",
			"LightMuted": "#b6c2c2",
			"DarkMuted": "#2f3f48"
		},
		"scene_name": "Laptop At Table",
		"scene_id": "b65bd153-a225-4ed3-9740-e994af5e64c8"
	},
	{
		"clip_id": "da07bea8-f432-487e-99ad-c8f41ebfff45",
		"scene_lqip": "https://s3.amazonaws.com/storytape-prod-static/scene_a22ffdd8-138b-4b3f-a615-facb61c6dd59/lqip_d819d9e4-6bea-405a-a3c7-ed9a3c677766.jpg",
		"scene_clip_count": "20",
		"published_at": "2017-10-26T13:14:14.956Z",
		"clip_sequence": [
			"https://s3.amazonaws.com/storytape-prod-static/da07bea8-f432-487e-99ad-c8f41ebfff45/sequence_8055fce0-080c-4058-977e-f73a225c2978/0000.png",
			"https://s3.amazonaws.com/storytape-prod-static/da07bea8-f432-487e-99ad-c8f41ebfff45/sequence_8055fce0-080c-4058-977e-f73a225c2978/0001.png",
			"https://s3.amazonaws.com/storytape-prod-static/da07bea8-f432-487e-99ad-c8f41ebfff45/sequence_8055fce0-080c-4058-977e-f73a225c2978/0002.png",
			"https://s3.amazonaws.com/storytape-prod-static/da07bea8-f432-487e-99ad-c8f41ebfff45/sequence_8055fce0-080c-4058-977e-f73a225c2978/0003.png",
			"https://s3.amazonaws.com/storytape-prod-static/da07bea8-f432-487e-99ad-c8f41ebfff45/sequence_8055fce0-080c-4058-977e-f73a225c2978/0004.png",
			"https://s3.amazonaws.com/storytape-prod-static/da07bea8-f432-487e-99ad-c8f41ebfff45/sequence_8055fce0-080c-4058-977e-f73a225c2978/0005.png",
			"https://s3.amazonaws.com/storytape-prod-static/da07bea8-f432-487e-99ad-c8f41ebfff45/sequence_8055fce0-080c-4058-977e-f73a225c2978/0006.png",
			"https://s3.amazonaws.com/storytape-prod-static/da07bea8-f432-487e-99ad-c8f41ebfff45/sequence_8055fce0-080c-4058-977e-f73a225c2978/0007.png",
			"https://s3.amazonaws.com/storytape-prod-static/da07bea8-f432-487e-99ad-c8f41ebfff45/sequence_8055fce0-080c-4058-977e-f73a225c2978/0008.png",
			"https://s3.amazonaws.com/storytape-prod-static/da07bea8-f432-487e-99ad-c8f41ebfff45/sequence_8055fce0-080c-4058-977e-f73a225c2978/0009.png",
			"https://s3.amazonaws.com/storytape-prod-static/da07bea8-f432-487e-99ad-c8f41ebfff45/sequence_8055fce0-080c-4058-977e-f73a225c2978/0010.png",
			"https://s3.amazonaws.com/storytape-prod-static/da07bea8-f432-487e-99ad-c8f41ebfff45/sequence_8055fce0-080c-4058-977e-f73a225c2978/0011.png",
			"https://s3.amazonaws.com/storytape-prod-static/da07bea8-f432-487e-99ad-c8f41ebfff45/sequence_8055fce0-080c-4058-977e-f73a225c2978/0012.png",
			"https://s3.amazonaws.com/storytape-prod-static/da07bea8-f432-487e-99ad-c8f41ebfff45/sequence_8055fce0-080c-4058-977e-f73a225c2978/0013.png",
			"https://s3.amazonaws.com/storytape-prod-static/da07bea8-f432-487e-99ad-c8f41ebfff45/sequence_8055fce0-080c-4058-977e-f73a225c2978/0014.png",
			"https://s3.amazonaws.com/storytape-prod-static/da07bea8-f432-487e-99ad-c8f41ebfff45/sequence_8055fce0-080c-4058-977e-f73a225c2978/0015.png",
			"https://s3.amazonaws.com/storytape-prod-static/da07bea8-f432-487e-99ad-c8f41ebfff45/sequence_8055fce0-080c-4058-977e-f73a225c2978/0016.png",
			"https://s3.amazonaws.com/storytape-prod-static/da07bea8-f432-487e-99ad-c8f41ebfff45/sequence_8055fce0-080c-4058-977e-f73a225c2978/0017.png",
			"https://s3.amazonaws.com/storytape-prod-static/da07bea8-f432-487e-99ad-c8f41ebfff45/sequence_8055fce0-080c-4058-977e-f73a225c2978/0018.png",
			"https://s3.amazonaws.com/storytape-prod-static/da07bea8-f432-487e-99ad-c8f41ebfff45/sequence_8055fce0-080c-4058-977e-f73a225c2978/0019.png",
			"https://s3.amazonaws.com/storytape-prod-static/da07bea8-f432-487e-99ad-c8f41ebfff45/sequence_8055fce0-080c-4058-977e-f73a225c2978/0020.png",
			"https://s3.amazonaws.com/storytape-prod-static/da07bea8-f432-487e-99ad-c8f41ebfff45/sequence_8055fce0-080c-4058-977e-f73a225c2978/0021.png",
			"https://s3.amazonaws.com/storytape-prod-static/da07bea8-f432-487e-99ad-c8f41ebfff45/sequence_8055fce0-080c-4058-977e-f73a225c2978/0022.png",
			"https://s3.amazonaws.com/storytape-prod-static/da07bea8-f432-487e-99ad-c8f41ebfff45/sequence_8055fce0-080c-4058-977e-f73a225c2978/0023.png",
			"https://s3.amazonaws.com/storytape-prod-static/da07bea8-f432-487e-99ad-c8f41ebfff45/sequence_8055fce0-080c-4058-977e-f73a225c2978/0024.png",
			"https://s3.amazonaws.com/storytape-prod-static/da07bea8-f432-487e-99ad-c8f41ebfff45/sequence_8055fce0-080c-4058-977e-f73a225c2978/0025.png",
			"https://s3.amazonaws.com/storytape-prod-static/da07bea8-f432-487e-99ad-c8f41ebfff45/sequence_8055fce0-080c-4058-977e-f73a225c2978/0026.png",
			"https://s3.amazonaws.com/storytape-prod-static/da07bea8-f432-487e-99ad-c8f41ebfff45/sequence_8055fce0-080c-4058-977e-f73a225c2978/0027.png",
			"https://s3.amazonaws.com/storytape-prod-static/da07bea8-f432-487e-99ad-c8f41ebfff45/sequence_8055fce0-080c-4058-977e-f73a225c2978/0028.png",
			"https://s3.amazonaws.com/storytape-prod-static/da07bea8-f432-487e-99ad-c8f41ebfff45/sequence_8055fce0-080c-4058-977e-f73a225c2978/0029.png",
			"https://s3.amazonaws.com/storytape-prod-static/da07bea8-f432-487e-99ad-c8f41ebfff45/sequence_8055fce0-080c-4058-977e-f73a225c2978/0030.png",
			"https://s3.amazonaws.com/storytape-prod-static/da07bea8-f432-487e-99ad-c8f41ebfff45/sequence_8055fce0-080c-4058-977e-f73a225c2978/0031.png",
			"https://s3.amazonaws.com/storytape-prod-static/da07bea8-f432-487e-99ad-c8f41ebfff45/sequence_8055fce0-080c-4058-977e-f73a225c2978/0032.png",
			"https://s3.amazonaws.com/storytape-prod-static/da07bea8-f432-487e-99ad-c8f41ebfff45/sequence_8055fce0-080c-4058-977e-f73a225c2978/0033.png",
			"https://s3.amazonaws.com/storytape-prod-static/da07bea8-f432-487e-99ad-c8f41ebfff45/sequence_8055fce0-080c-4058-977e-f73a225c2978/0034.png",
			"https://s3.amazonaws.com/storytape-prod-static/da07bea8-f432-487e-99ad-c8f41ebfff45/sequence_8055fce0-080c-4058-977e-f73a225c2978/0035.png",
			"https://s3.amazonaws.com/storytape-prod-static/da07bea8-f432-487e-99ad-c8f41ebfff45/sequence_8055fce0-080c-4058-977e-f73a225c2978/0036.png",
			"https://s3.amazonaws.com/storytape-prod-static/da07bea8-f432-487e-99ad-c8f41ebfff45/sequence_8055fce0-080c-4058-977e-f73a225c2978/0037.png",
			"https://s3.amazonaws.com/storytape-prod-static/da07bea8-f432-487e-99ad-c8f41ebfff45/sequence_8055fce0-080c-4058-977e-f73a225c2978/0038.png",
			"https://s3.amazonaws.com/storytape-prod-static/da07bea8-f432-487e-99ad-c8f41ebfff45/sequence_8055fce0-080c-4058-977e-f73a225c2978/0039.png",
			"https://s3.amazonaws.com/storytape-prod-static/da07bea8-f432-487e-99ad-c8f41ebfff45/sequence_8055fce0-080c-4058-977e-f73a225c2978/0040.png"
		],
		"keywords": [
			"above",
			"air",
			"airplane",
			"background",
			"beautiful",
			"cloud",
			"cloudscape",
			"dreams",
			"evening",
			"flight",
			"flying",
			"freedom",
			"god",
			"heaven",
			"high",
			"horizon",
			"intro",
			"loop",
			"loopable",
			"morning",
			"motion",
			"nature",
			"over",
			"purple",
			"relax",
			"relaxation",
			"seamless",
			"sky",
			"space",
			"sun",
			"sunbeam",
			"sunrise",
			"sunset",
			"sunshine"
		],
		"clip_slug": "beams-of-light-from-sun-above-purple-clouds",
		"clip_poster": "https://s3.amazonaws.com/storytape-prod-static/da07bea8-f432-487e-99ad-c8f41ebfff45/poster_0000_ae34e5e4-58ec-40e2-b23f-921cb0a57b29.png",
		"clip_preview_large": "https://s3.amazonaws.com/storytape-prod-static/da07bea8-f432-487e-99ad-c8f41ebfff45/preview-large-a6e75c1d-9793-4ffc-80fd-472712d52140.mp4",
		"clip_length": 20000,
		"scene_description": "In an almost heavenly realm above the clouds, the sun radiates pink, peach, and purple hues, giving the clouds a unique look and texture.",
		"clip_thumbnail": "https://s3.amazonaws.com/storytape-prod-static/da07bea8-f432-487e-99ad-c8f41ebfff45/thumbnail_0000_62c99a44-3f2d-4a76-ad28-2c0fd8bc5a10.png",
		"clip_name": "Beams of light from sun above purple clouds",
		"scene_thumbnail": "https://s3.amazonaws.com/storytape-prod-static/scene_a22ffdd8-138b-4b3f-a615-facb61c6dd59/thumbnail_6017d767-3452-4cb6-ae4c-9f0e52735aec.jpg",
		"clip_preview_small": "https://s3.amazonaws.com/storytape-prod-static/da07bea8-f432-487e-99ad-c8f41ebfff45/preview-small-3be3c63b-462d-46ed-a754-c1a7fe10eea1.mp4",
		"tags": [
			4400,
			1100,
			2700,
			4200,
			900,
			2300,
			2100,
			3000,
			3600,
			200,
			3400
		],
		"featured_at": "2017-11-14T07:11:02.36Z",
		"clip_lqip": "https://s3.amazonaws.com/storytape-prod-static/scene_da07bea8-f432-487e-99ad-c8f41ebfff45/lqip_28226e15-1820-4453-8f9f-e038c83b0fb9.jpg",
		"scene_poster": "https://s3.amazonaws.com/storytape-prod-static/scene_a22ffdd8-138b-4b3f-a615-facb61c6dd59/poster_d1f5a057-3c44-4885-bcb8-50bd93ba9b98.jpg",
		"scene_slug": "above-the-clouds",
		"clip_colors": {
			"Vibrant": "#d0a691",
			"LightVibrant": "#ecc09f",
			"DarkVibrant": "#5c3927",
			"Muted": "#907a85",
			"LightMuted": "#ceb3a6",
			"DarkMuted": "#5c5366"
		},
		"scene_colors": {
			"Vibrant": "#cca48c",
			"LightVibrant": "#d2b29c",
			"DarkVibrant": "#5b3b28",
			"Muted": "#9a7f81",
			"LightMuted": "#dccab9",
			"DarkMuted": "#544d5b"
		},
		"scene_name": "Above The Clouds",
		"scene_id": "a22ffdd8-138b-4b3f-a615-facb61c6dd59"
	},
	{
		"clip_id": "fcae6fdd-880c-4900-938b-ae3137940a28",
		"scene_lqip": "https://s3.amazonaws.com/storytape-prod-static/scene_80ccac39-2d47-42ba-b498-d1ba304ad1d1/lqip_16261d85-454a-4f0a-ac82-9c06ed922c36.jpg",
		"scene_clip_count": "75",
		"published_at": "2017-11-02T20:57:37.863Z",
		"clip_sequence": [
			"https://s3.amazonaws.com/storytape-prod-static/fcae6fdd-880c-4900-938b-ae3137940a28/sequence_9cafe10c-ac14-4072-a3de-255f4c5f3143/0000.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcae6fdd-880c-4900-938b-ae3137940a28/sequence_9cafe10c-ac14-4072-a3de-255f4c5f3143/0001.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcae6fdd-880c-4900-938b-ae3137940a28/sequence_9cafe10c-ac14-4072-a3de-255f4c5f3143/0002.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcae6fdd-880c-4900-938b-ae3137940a28/sequence_9cafe10c-ac14-4072-a3de-255f4c5f3143/0003.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcae6fdd-880c-4900-938b-ae3137940a28/sequence_9cafe10c-ac14-4072-a3de-255f4c5f3143/0004.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcae6fdd-880c-4900-938b-ae3137940a28/sequence_9cafe10c-ac14-4072-a3de-255f4c5f3143/0005.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcae6fdd-880c-4900-938b-ae3137940a28/sequence_9cafe10c-ac14-4072-a3de-255f4c5f3143/0006.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcae6fdd-880c-4900-938b-ae3137940a28/sequence_9cafe10c-ac14-4072-a3de-255f4c5f3143/0007.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcae6fdd-880c-4900-938b-ae3137940a28/sequence_9cafe10c-ac14-4072-a3de-255f4c5f3143/0008.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcae6fdd-880c-4900-938b-ae3137940a28/sequence_9cafe10c-ac14-4072-a3de-255f4c5f3143/0009.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcae6fdd-880c-4900-938b-ae3137940a28/sequence_9cafe10c-ac14-4072-a3de-255f4c5f3143/0010.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcae6fdd-880c-4900-938b-ae3137940a28/sequence_9cafe10c-ac14-4072-a3de-255f4c5f3143/0011.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcae6fdd-880c-4900-938b-ae3137940a28/sequence_9cafe10c-ac14-4072-a3de-255f4c5f3143/0012.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcae6fdd-880c-4900-938b-ae3137940a28/sequence_9cafe10c-ac14-4072-a3de-255f4c5f3143/0013.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcae6fdd-880c-4900-938b-ae3137940a28/sequence_9cafe10c-ac14-4072-a3de-255f4c5f3143/0014.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcae6fdd-880c-4900-938b-ae3137940a28/sequence_9cafe10c-ac14-4072-a3de-255f4c5f3143/0015.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcae6fdd-880c-4900-938b-ae3137940a28/sequence_9cafe10c-ac14-4072-a3de-255f4c5f3143/0016.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcae6fdd-880c-4900-938b-ae3137940a28/sequence_9cafe10c-ac14-4072-a3de-255f4c5f3143/0017.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcae6fdd-880c-4900-938b-ae3137940a28/sequence_9cafe10c-ac14-4072-a3de-255f4c5f3143/0018.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcae6fdd-880c-4900-938b-ae3137940a28/sequence_9cafe10c-ac14-4072-a3de-255f4c5f3143/0019.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcae6fdd-880c-4900-938b-ae3137940a28/sequence_9cafe10c-ac14-4072-a3de-255f4c5f3143/0020.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcae6fdd-880c-4900-938b-ae3137940a28/sequence_9cafe10c-ac14-4072-a3de-255f4c5f3143/0021.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcae6fdd-880c-4900-938b-ae3137940a28/sequence_9cafe10c-ac14-4072-a3de-255f4c5f3143/0022.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcae6fdd-880c-4900-938b-ae3137940a28/sequence_9cafe10c-ac14-4072-a3de-255f4c5f3143/0023.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcae6fdd-880c-4900-938b-ae3137940a28/sequence_9cafe10c-ac14-4072-a3de-255f4c5f3143/0024.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcae6fdd-880c-4900-938b-ae3137940a28/sequence_9cafe10c-ac14-4072-a3de-255f4c5f3143/0025.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcae6fdd-880c-4900-938b-ae3137940a28/sequence_9cafe10c-ac14-4072-a3de-255f4c5f3143/0026.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcae6fdd-880c-4900-938b-ae3137940a28/sequence_9cafe10c-ac14-4072-a3de-255f4c5f3143/0027.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcae6fdd-880c-4900-938b-ae3137940a28/sequence_9cafe10c-ac14-4072-a3de-255f4c5f3143/0028.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcae6fdd-880c-4900-938b-ae3137940a28/sequence_9cafe10c-ac14-4072-a3de-255f4c5f3143/0029.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcae6fdd-880c-4900-938b-ae3137940a28/sequence_9cafe10c-ac14-4072-a3de-255f4c5f3143/0030.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcae6fdd-880c-4900-938b-ae3137940a28/sequence_9cafe10c-ac14-4072-a3de-255f4c5f3143/0031.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcae6fdd-880c-4900-938b-ae3137940a28/sequence_9cafe10c-ac14-4072-a3de-255f4c5f3143/0032.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcae6fdd-880c-4900-938b-ae3137940a28/sequence_9cafe10c-ac14-4072-a3de-255f4c5f3143/0033.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcae6fdd-880c-4900-938b-ae3137940a28/sequence_9cafe10c-ac14-4072-a3de-255f4c5f3143/0034.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcae6fdd-880c-4900-938b-ae3137940a28/sequence_9cafe10c-ac14-4072-a3de-255f4c5f3143/0035.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcae6fdd-880c-4900-938b-ae3137940a28/sequence_9cafe10c-ac14-4072-a3de-255f4c5f3143/0036.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcae6fdd-880c-4900-938b-ae3137940a28/sequence_9cafe10c-ac14-4072-a3de-255f4c5f3143/0037.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcae6fdd-880c-4900-938b-ae3137940a28/sequence_9cafe10c-ac14-4072-a3de-255f4c5f3143/0038.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcae6fdd-880c-4900-938b-ae3137940a28/sequence_9cafe10c-ac14-4072-a3de-255f4c5f3143/0039.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcae6fdd-880c-4900-938b-ae3137940a28/sequence_9cafe10c-ac14-4072-a3de-255f4c5f3143/0040.png"
		],
		"keywords": [
			"abstract",
			"backgrounds",
			"chalk",
			"color",
			"colour",
			"concepts",
			"dust",
			"flash",
			"fog",
			"fumes",
			"ideas",
			"light",
			"motion",
			"multi",
			"smoke",
			"smoking",
			"speaker",
			"steam",
			"strobe",
			"white"
		],
		"clip_slug": "multi-colored-light-strobing-as-chalk-bounces-around-middle-of-speaker-cone",
		"clip_poster": "https://s3.amazonaws.com/storytape-prod-static/fcae6fdd-880c-4900-938b-ae3137940a28/poster_0000_7df432d7-a3eb-4e5e-9542-d6cdda395f8f.png",
		"clip_preview_large": "https://s3.amazonaws.com/storytape-prod-static/fcae6fdd-880c-4900-938b-ae3137940a28/preview-large-4a0d8e72-97f3-4850-b854-2099f79bfdbd.mp4",
		"clip_length": 20000,
		"scene_description": "Using chalk dust, strobe lights, a speaker, and a synthesizer, an experimental scene is born. As the music passes through the speakers, the light reveals the chalk in control of the sound waves.",
		"clip_thumbnail": "https://s3.amazonaws.com/storytape-prod-static/fcae6fdd-880c-4900-938b-ae3137940a28/thumbnail_0000_5ac0604a-4fba-4def-90b6-d0a274678cb3.png",
		"clip_name": "Multi colored light strobing as chalk bounces around middle of speaker cone",
		"scene_thumbnail": "https://s3.amazonaws.com/storytape-prod-static/scene_80ccac39-2d47-42ba-b498-d1ba304ad1d1/thumbnail_8dcfa6e6-24f8-478e-b3a7-7c21663e57e6.jpg",
		"clip_preview_small": "https://s3.amazonaws.com/storytape-prod-static/fcae6fdd-880c-4900-938b-ae3137940a28/preview-small-91429676-a80b-4ded-b1e5-c81566e6b7d2.mp4",
		"tags": [
			4600,
			4400,
			2500,
			3900,
			2200,
			4000,
			1900,
			2000,
			100,
			1500
		],
		"clip_lqip": "https://s3.amazonaws.com/storytape-prod-static/scene_fcae6fdd-880c-4900-938b-ae3137940a28/lqip_cc1efd24-b174-4619-bb6b-5449351985e0.jpg",
		"scene_poster": "https://s3.amazonaws.com/storytape-prod-static/scene_80ccac39-2d47-42ba-b498-d1ba304ad1d1/poster_38f9b661-9e7e-409b-896f-ce07193f95c3.jpg",
		"scene_slug": "strange-speaker",
		"clip_colors": {
			"Vibrant": "#44c854",
			"LightVibrant": "#88a0e0",
			"DarkVibrant": "#1e6626",
			"Muted": "#8ca5a9",
			"LightMuted": "#b3c7ce",
			"DarkMuted": "#292c32"
		},
		"scene_colors": {
			"Vibrant": "#d41744",
			"LightVibrant": "#cb4f88",
			"DarkVibrant": "#7e0827",
			"Muted": "#303a70",
			"DarkMuted": "#28345a"
		},
		"scene_name": "Strange Speaker",
		"scene_id": "80ccac39-2d47-42ba-b498-d1ba304ad1d1"
	},
	{
		"clip_id": "e419978c-7c93-48d0-9cfa-cefa25750378",
		"scene_lqip": "https://s3.amazonaws.com/storytape-prod-static/scene_726d7ed1-a7a0-42a4-94d7-7ca403201ade/lqip_246da8eb-2e86-4d88-926c-7bd1441720f5.jpg",
		"scene_clip_count": "18",
		"published_at": "2017-11-07T17:06:31.561Z",
		"clip_sequence": [
			"https://s3.amazonaws.com/storytape-prod-static/e419978c-7c93-48d0-9cfa-cefa25750378/sequence_21347f55-b3e3-444e-a913-d1d8092e4465/0000.png",
			"https://s3.amazonaws.com/storytape-prod-static/e419978c-7c93-48d0-9cfa-cefa25750378/sequence_21347f55-b3e3-444e-a913-d1d8092e4465/0001.png",
			"https://s3.amazonaws.com/storytape-prod-static/e419978c-7c93-48d0-9cfa-cefa25750378/sequence_21347f55-b3e3-444e-a913-d1d8092e4465/0002.png",
			"https://s3.amazonaws.com/storytape-prod-static/e419978c-7c93-48d0-9cfa-cefa25750378/sequence_21347f55-b3e3-444e-a913-d1d8092e4465/0003.png",
			"https://s3.amazonaws.com/storytape-prod-static/e419978c-7c93-48d0-9cfa-cefa25750378/sequence_21347f55-b3e3-444e-a913-d1d8092e4465/0004.png",
			"https://s3.amazonaws.com/storytape-prod-static/e419978c-7c93-48d0-9cfa-cefa25750378/sequence_21347f55-b3e3-444e-a913-d1d8092e4465/0005.png",
			"https://s3.amazonaws.com/storytape-prod-static/e419978c-7c93-48d0-9cfa-cefa25750378/sequence_21347f55-b3e3-444e-a913-d1d8092e4465/0006.png",
			"https://s3.amazonaws.com/storytape-prod-static/e419978c-7c93-48d0-9cfa-cefa25750378/sequence_21347f55-b3e3-444e-a913-d1d8092e4465/0007.png",
			"https://s3.amazonaws.com/storytape-prod-static/e419978c-7c93-48d0-9cfa-cefa25750378/sequence_21347f55-b3e3-444e-a913-d1d8092e4465/0008.png",
			"https://s3.amazonaws.com/storytape-prod-static/e419978c-7c93-48d0-9cfa-cefa25750378/sequence_21347f55-b3e3-444e-a913-d1d8092e4465/0009.png",
			"https://s3.amazonaws.com/storytape-prod-static/e419978c-7c93-48d0-9cfa-cefa25750378/sequence_21347f55-b3e3-444e-a913-d1d8092e4465/0010.png",
			"https://s3.amazonaws.com/storytape-prod-static/e419978c-7c93-48d0-9cfa-cefa25750378/sequence_21347f55-b3e3-444e-a913-d1d8092e4465/0011.png",
			"https://s3.amazonaws.com/storytape-prod-static/e419978c-7c93-48d0-9cfa-cefa25750378/sequence_21347f55-b3e3-444e-a913-d1d8092e4465/0012.png",
			"https://s3.amazonaws.com/storytape-prod-static/e419978c-7c93-48d0-9cfa-cefa25750378/sequence_21347f55-b3e3-444e-a913-d1d8092e4465/0013.png",
			"https://s3.amazonaws.com/storytape-prod-static/e419978c-7c93-48d0-9cfa-cefa25750378/sequence_21347f55-b3e3-444e-a913-d1d8092e4465/0014.png",
			"https://s3.amazonaws.com/storytape-prod-static/e419978c-7c93-48d0-9cfa-cefa25750378/sequence_21347f55-b3e3-444e-a913-d1d8092e4465/0015.png",
			"https://s3.amazonaws.com/storytape-prod-static/e419978c-7c93-48d0-9cfa-cefa25750378/sequence_21347f55-b3e3-444e-a913-d1d8092e4465/0016.png",
			"https://s3.amazonaws.com/storytape-prod-static/e419978c-7c93-48d0-9cfa-cefa25750378/sequence_21347f55-b3e3-444e-a913-d1d8092e4465/0017.png",
			"https://s3.amazonaws.com/storytape-prod-static/e419978c-7c93-48d0-9cfa-cefa25750378/sequence_21347f55-b3e3-444e-a913-d1d8092e4465/0018.png",
			"https://s3.amazonaws.com/storytape-prod-static/e419978c-7c93-48d0-9cfa-cefa25750378/sequence_21347f55-b3e3-444e-a913-d1d8092e4465/0019.png",
			"https://s3.amazonaws.com/storytape-prod-static/e419978c-7c93-48d0-9cfa-cefa25750378/sequence_21347f55-b3e3-444e-a913-d1d8092e4465/0020.png",
			"https://s3.amazonaws.com/storytape-prod-static/e419978c-7c93-48d0-9cfa-cefa25750378/sequence_21347f55-b3e3-444e-a913-d1d8092e4465/0021.png",
			"https://s3.amazonaws.com/storytape-prod-static/e419978c-7c93-48d0-9cfa-cefa25750378/sequence_21347f55-b3e3-444e-a913-d1d8092e4465/0022.png",
			"https://s3.amazonaws.com/storytape-prod-static/e419978c-7c93-48d0-9cfa-cefa25750378/sequence_21347f55-b3e3-444e-a913-d1d8092e4465/0023.png",
			"https://s3.amazonaws.com/storytape-prod-static/e419978c-7c93-48d0-9cfa-cefa25750378/sequence_21347f55-b3e3-444e-a913-d1d8092e4465/0024.png",
			"https://s3.amazonaws.com/storytape-prod-static/e419978c-7c93-48d0-9cfa-cefa25750378/sequence_21347f55-b3e3-444e-a913-d1d8092e4465/0025.png",
			"https://s3.amazonaws.com/storytape-prod-static/e419978c-7c93-48d0-9cfa-cefa25750378/sequence_21347f55-b3e3-444e-a913-d1d8092e4465/0026.png",
			"https://s3.amazonaws.com/storytape-prod-static/e419978c-7c93-48d0-9cfa-cefa25750378/sequence_21347f55-b3e3-444e-a913-d1d8092e4465/0027.png",
			"https://s3.amazonaws.com/storytape-prod-static/e419978c-7c93-48d0-9cfa-cefa25750378/sequence_21347f55-b3e3-444e-a913-d1d8092e4465/0028.png",
			"https://s3.amazonaws.com/storytape-prod-static/e419978c-7c93-48d0-9cfa-cefa25750378/sequence_21347f55-b3e3-444e-a913-d1d8092e4465/0029.png",
			"https://s3.amazonaws.com/storytape-prod-static/e419978c-7c93-48d0-9cfa-cefa25750378/sequence_21347f55-b3e3-444e-a913-d1d8092e4465/0030.png",
			"https://s3.amazonaws.com/storytape-prod-static/e419978c-7c93-48d0-9cfa-cefa25750378/sequence_21347f55-b3e3-444e-a913-d1d8092e4465/0031.png",
			"https://s3.amazonaws.com/storytape-prod-static/e419978c-7c93-48d0-9cfa-cefa25750378/sequence_21347f55-b3e3-444e-a913-d1d8092e4465/0032.png",
			"https://s3.amazonaws.com/storytape-prod-static/e419978c-7c93-48d0-9cfa-cefa25750378/sequence_21347f55-b3e3-444e-a913-d1d8092e4465/0033.png",
			"https://s3.amazonaws.com/storytape-prod-static/e419978c-7c93-48d0-9cfa-cefa25750378/sequence_21347f55-b3e3-444e-a913-d1d8092e4465/0034.png",
			"https://s3.amazonaws.com/storytape-prod-static/e419978c-7c93-48d0-9cfa-cefa25750378/sequence_21347f55-b3e3-444e-a913-d1d8092e4465/0035.png",
			"https://s3.amazonaws.com/storytape-prod-static/e419978c-7c93-48d0-9cfa-cefa25750378/sequence_21347f55-b3e3-444e-a913-d1d8092e4465/0036.png",
			"https://s3.amazonaws.com/storytape-prod-static/e419978c-7c93-48d0-9cfa-cefa25750378/sequence_21347f55-b3e3-444e-a913-d1d8092e4465/0037.png",
			"https://s3.amazonaws.com/storytape-prod-static/e419978c-7c93-48d0-9cfa-cefa25750378/sequence_21347f55-b3e3-444e-a913-d1d8092e4465/0038.png",
			"https://s3.amazonaws.com/storytape-prod-static/e419978c-7c93-48d0-9cfa-cefa25750378/sequence_21347f55-b3e3-444e-a913-d1d8092e4465/0039.png",
			"https://s3.amazonaws.com/storytape-prod-static/e419978c-7c93-48d0-9cfa-cefa25750378/sequence_21347f55-b3e3-444e-a913-d1d8092e4465/0040.png"
		],
		"keywords": [
			"aerial",
			"agriculture",
			"arctic",
			"awe",
			"cliff",
			"colour",
			"destination",
			"eco",
			"energy",
			"environment",
			"fertile",
			"flowing",
			"freshness",
			"frozen",
			"glacial",
			"green",
			"holidays",
			"ice",
			"iceland",
			"land",
			"landscape",
			"mineral",
			"misty",
			"mountain",
			"nature",
			"nautical vessel",
			"northern",
			"northern hemisphere",
			"plain",
			"plateau",
			"power",
			"research",
			"ridge",
			"rural",
			"scenic",
			"spray",
			"terrain",
			"tourism",
			"tourist",
			"tradition",
			"travel",
			"vacation",
			"vibrant",
			"view",
			"water",
			"waterfall",
			"wild",
			"wilderness"
		],
		"clip_slug": "pouring-waterfall-at-the-end-of-a-grassy-cliff",
		"clip_poster": "https://s3.amazonaws.com/storytape-prod-static/e419978c-7c93-48d0-9cfa-cefa25750378/poster_0000_2a43d021-ff29-4be1-8a9f-07d2cbf1203d.png",
		"clip_preview_large": "https://s3.amazonaws.com/storytape-prod-static/e419978c-7c93-48d0-9cfa-cefa25750378/preview-large-fca8d88d-0817-404e-bc33-b01162777f92.mp4",
		"clip_length": 20000,
		"scene_description": "A thin waterfall flowing with ice-cold glacier water. A mossy landscape drops off where the river crashes down below and continues to flow.",
		"clip_thumbnail": "https://s3.amazonaws.com/storytape-prod-static/e419978c-7c93-48d0-9cfa-cefa25750378/thumbnail_0000_ad7c7160-70a6-4bd3-bf75-49ef37753e93.png",
		"clip_name": "Pouring waterfall at the end of a grassy cliff",
		"scene_thumbnail": "https://s3.amazonaws.com/storytape-prod-static/scene_726d7ed1-a7a0-42a4-94d7-7ca403201ade/thumbnail_b48ae8cf-20a3-4d0e-a1d2-0093c36736ba.jpg",
		"clip_preview_small": "https://s3.amazonaws.com/storytape-prod-static/e419978c-7c93-48d0-9cfa-cefa25750378/preview-small-59b5d554-1933-4e77-9e3c-f3352b90d7d5.mp4",
		"tags": [
			2900,
			4400,
			1100,
			2700,
			4200,
			900,
			2300,
			2100,
			3600,
			200,
			3300
		],
		"featured_at": "2017-11-14T07:10:22.41Z",
		"clip_lqip": "https://s3.amazonaws.com/storytape-prod-static/scene_e419978c-7c93-48d0-9cfa-cefa25750378/lqip_f6975bf3-84a7-4fba-ac8f-862a79e5a4ce.jpg",
		"scene_poster": "https://s3.amazonaws.com/storytape-prod-static/scene_726d7ed1-a7a0-42a4-94d7-7ca403201ade/poster_c7402bd9-2302-433f-8c97-a02e5937160d.jpg",
		"scene_slug": "green-waterfall",
		"clip_colors": {
			"Vibrant": "#c7ad37",
			"DarkVibrant": "#64571c",
			"Muted": "#655a36",
			"LightMuted": "#d4d4dc",
			"DarkMuted": "#564d36"
		},
		"scene_colors": {
			"Vibrant": "#74642c",
			"DarkVibrant": "#5b5229",
			"Muted": "#747c8c",
			"LightMuted": "#d4d4dc",
			"DarkMuted": "#4a4627"
		},
		"scene_name": "Green Waterfall",
		"scene_id": "726d7ed1-a7a0-42a4-94d7-7ca403201ade"
	},
	{
		"clip_id": "f4e4e867-0247-40ef-9991-1062e24e88d1",
		"scene_lqip": "https://s3.amazonaws.com/storytape-prod-static/scene_b76ac89f-6a2d-4e9f-ae17-9bc45a89624d/lqip_51fd0416-a384-4b5a-9ad0-809500b1f6f5.jpg",
		"scene_clip_count": "18",
		"published_at": "2017-11-06T19:30:26.317Z",
		"clip_sequence": [
			"https://s3.amazonaws.com/storytape-prod-static/f4e4e867-0247-40ef-9991-1062e24e88d1/sequence_14995587-fe63-465b-9fb9-d82cdb8775a4/0000.png",
			"https://s3.amazonaws.com/storytape-prod-static/f4e4e867-0247-40ef-9991-1062e24e88d1/sequence_14995587-fe63-465b-9fb9-d82cdb8775a4/0001.png",
			"https://s3.amazonaws.com/storytape-prod-static/f4e4e867-0247-40ef-9991-1062e24e88d1/sequence_14995587-fe63-465b-9fb9-d82cdb8775a4/0002.png",
			"https://s3.amazonaws.com/storytape-prod-static/f4e4e867-0247-40ef-9991-1062e24e88d1/sequence_14995587-fe63-465b-9fb9-d82cdb8775a4/0003.png",
			"https://s3.amazonaws.com/storytape-prod-static/f4e4e867-0247-40ef-9991-1062e24e88d1/sequence_14995587-fe63-465b-9fb9-d82cdb8775a4/0004.png",
			"https://s3.amazonaws.com/storytape-prod-static/f4e4e867-0247-40ef-9991-1062e24e88d1/sequence_14995587-fe63-465b-9fb9-d82cdb8775a4/0005.png",
			"https://s3.amazonaws.com/storytape-prod-static/f4e4e867-0247-40ef-9991-1062e24e88d1/sequence_14995587-fe63-465b-9fb9-d82cdb8775a4/0006.png",
			"https://s3.amazonaws.com/storytape-prod-static/f4e4e867-0247-40ef-9991-1062e24e88d1/sequence_14995587-fe63-465b-9fb9-d82cdb8775a4/0007.png",
			"https://s3.amazonaws.com/storytape-prod-static/f4e4e867-0247-40ef-9991-1062e24e88d1/sequence_14995587-fe63-465b-9fb9-d82cdb8775a4/0008.png",
			"https://s3.amazonaws.com/storytape-prod-static/f4e4e867-0247-40ef-9991-1062e24e88d1/sequence_14995587-fe63-465b-9fb9-d82cdb8775a4/0009.png",
			"https://s3.amazonaws.com/storytape-prod-static/f4e4e867-0247-40ef-9991-1062e24e88d1/sequence_14995587-fe63-465b-9fb9-d82cdb8775a4/0010.png",
			"https://s3.amazonaws.com/storytape-prod-static/f4e4e867-0247-40ef-9991-1062e24e88d1/sequence_14995587-fe63-465b-9fb9-d82cdb8775a4/0011.png",
			"https://s3.amazonaws.com/storytape-prod-static/f4e4e867-0247-40ef-9991-1062e24e88d1/sequence_14995587-fe63-465b-9fb9-d82cdb8775a4/0012.png",
			"https://s3.amazonaws.com/storytape-prod-static/f4e4e867-0247-40ef-9991-1062e24e88d1/sequence_14995587-fe63-465b-9fb9-d82cdb8775a4/0013.png",
			"https://s3.amazonaws.com/storytape-prod-static/f4e4e867-0247-40ef-9991-1062e24e88d1/sequence_14995587-fe63-465b-9fb9-d82cdb8775a4/0014.png",
			"https://s3.amazonaws.com/storytape-prod-static/f4e4e867-0247-40ef-9991-1062e24e88d1/sequence_14995587-fe63-465b-9fb9-d82cdb8775a4/0015.png",
			"https://s3.amazonaws.com/storytape-prod-static/f4e4e867-0247-40ef-9991-1062e24e88d1/sequence_14995587-fe63-465b-9fb9-d82cdb8775a4/0016.png",
			"https://s3.amazonaws.com/storytape-prod-static/f4e4e867-0247-40ef-9991-1062e24e88d1/sequence_14995587-fe63-465b-9fb9-d82cdb8775a4/0017.png",
			"https://s3.amazonaws.com/storytape-prod-static/f4e4e867-0247-40ef-9991-1062e24e88d1/sequence_14995587-fe63-465b-9fb9-d82cdb8775a4/0018.png",
			"https://s3.amazonaws.com/storytape-prod-static/f4e4e867-0247-40ef-9991-1062e24e88d1/sequence_14995587-fe63-465b-9fb9-d82cdb8775a4/0019.png",
			"https://s3.amazonaws.com/storytape-prod-static/f4e4e867-0247-40ef-9991-1062e24e88d1/sequence_14995587-fe63-465b-9fb9-d82cdb8775a4/0020.png",
			"https://s3.amazonaws.com/storytape-prod-static/f4e4e867-0247-40ef-9991-1062e24e88d1/sequence_14995587-fe63-465b-9fb9-d82cdb8775a4/0021.png",
			"https://s3.amazonaws.com/storytape-prod-static/f4e4e867-0247-40ef-9991-1062e24e88d1/sequence_14995587-fe63-465b-9fb9-d82cdb8775a4/0022.png",
			"https://s3.amazonaws.com/storytape-prod-static/f4e4e867-0247-40ef-9991-1062e24e88d1/sequence_14995587-fe63-465b-9fb9-d82cdb8775a4/0023.png",
			"https://s3.amazonaws.com/storytape-prod-static/f4e4e867-0247-40ef-9991-1062e24e88d1/sequence_14995587-fe63-465b-9fb9-d82cdb8775a4/0024.png",
			"https://s3.amazonaws.com/storytape-prod-static/f4e4e867-0247-40ef-9991-1062e24e88d1/sequence_14995587-fe63-465b-9fb9-d82cdb8775a4/0025.png",
			"https://s3.amazonaws.com/storytape-prod-static/f4e4e867-0247-40ef-9991-1062e24e88d1/sequence_14995587-fe63-465b-9fb9-d82cdb8775a4/0026.png",
			"https://s3.amazonaws.com/storytape-prod-static/f4e4e867-0247-40ef-9991-1062e24e88d1/sequence_14995587-fe63-465b-9fb9-d82cdb8775a4/0027.png",
			"https://s3.amazonaws.com/storytape-prod-static/f4e4e867-0247-40ef-9991-1062e24e88d1/sequence_14995587-fe63-465b-9fb9-d82cdb8775a4/0028.png"
		],
		"keywords": [
			"autumn",
			"beautiful",
			"bond",
			"boy",
			"cabin",
			"coat",
			"cottage",
			"couple",
			"cute",
			"date",
			"embrace",
			"emotion",
			"fall",
			"forest",
			"fun",
			"girl",
			"hand",
			"handsome",
			"happy",
			"hold",
			"hug",
			"husband",
			"intense",
			"joy",
			"love kiss",
			"man",
			"marriage",
			"romantic",
			"rover",
			"skin",
			"smile",
			"sweater",
			"together",
			"touch",
			"tree",
			"walk",
			"water",
			"wife",
			"woman"
		],
		"clip_slug": "young-couple-looking-out-over-the-water",
		"clip_poster": "https://s3.amazonaws.com/storytape-prod-static/f4e4e867-0247-40ef-9991-1062e24e88d1/poster_0000_522e5168-7916-4770-9a36-73ad43f04a77.png",
		"clip_preview_large": "https://s3.amazonaws.com/storytape-prod-static/f4e4e867-0247-40ef-9991-1062e24e88d1/preview-large-ac1defc0-c168-4846-9142-690c6b364832.mp4",
		"clip_length": 14167,
		"scene_description": "Two young lovers display their love and affection with hand-holding, hugs, and kisses. On a crisp evening in the forest by a lake, standing on the dock makes for a very romantic scene.",
		"clip_thumbnail": "https://s3.amazonaws.com/storytape-prod-static/f4e4e867-0247-40ef-9991-1062e24e88d1/thumbnail_0000_dd50fc21-827d-4dcd-941e-2f7355b1a131.png",
		"clip_name": "Young couple looking out over the water",
		"scene_thumbnail": "https://s3.amazonaws.com/storytape-prod-static/scene_b76ac89f-6a2d-4e9f-ae17-9bc45a89624d/thumbnail_0baaab63-e594-4baf-b21b-d1ab788264db.jpg",
		"clip_preview_small": "https://s3.amazonaws.com/storytape-prod-static/f4e4e867-0247-40ef-9991-1062e24e88d1/preview-small-e6e94bf6-61d2-4963-8f8e-1b10add8600e.mp4",
		"tags": [
			1200,
			1100,
			2700,
			4300,
			4200,
			2300,
			3700,
			3000,
			2000,
			1000,
			1800,
			3400
		],
		"clip_lqip": "https://s3.amazonaws.com/storytape-prod-static/scene_f4e4e867-0247-40ef-9991-1062e24e88d1/lqip_cd558ee2-a8f8-4bd5-b61a-44133455ac3b.jpg",
		"scene_poster": "https://s3.amazonaws.com/storytape-prod-static/scene_b76ac89f-6a2d-4e9f-ae17-9bc45a89624d/poster_5ad2905e-775c-490d-bc35-39a9cdbe70d1.jpg",
		"scene_slug": "couple-in-love",
		"clip_colors": {
			"Vibrant": "#b44a5f",
			"DarkVibrant": "#441c24",
			"Muted": "#808492",
			"LightMuted": "#bbc0cb",
			"DarkMuted": "#2c3454"
		},
		"scene_colors": {
			"Vibrant": "#b94547",
			"DarkVibrant": "#552021",
			"Muted": "#737a8a",
			"LightMuted": "#bec1ca",
			"DarkMuted": "#5a2f2b"
		},
		"scene_name": "Couple In Love",
		"scene_id": "b76ac89f-6a2d-4e9f-ae17-9bc45a89624d"
	},
	{
		"clip_id": "fbb61ca3-d8aa-4333-818a-bf881348525b",
		"scene_lqip": "https://s3.amazonaws.com/storytape-prod-static/scene_3b8a9c7b-3847-477e-bb01-73350e86ca81/lqip_417c133e-b745-4c58-b88e-e72d0de7270b.jpg",
		"scene_clip_count": "32",
		"published_at": "2017-10-30T20:28:22.754Z",
		"clip_sequence": [
			"https://s3.amazonaws.com/storytape-prod-static/fbb61ca3-d8aa-4333-818a-bf881348525b/sequence_8e718f8c-6f5c-464f-bb9a-5ed6c23d10a8/0000.png",
			"https://s3.amazonaws.com/storytape-prod-static/fbb61ca3-d8aa-4333-818a-bf881348525b/sequence_8e718f8c-6f5c-464f-bb9a-5ed6c23d10a8/0001.png",
			"https://s3.amazonaws.com/storytape-prod-static/fbb61ca3-d8aa-4333-818a-bf881348525b/sequence_8e718f8c-6f5c-464f-bb9a-5ed6c23d10a8/0002.png",
			"https://s3.amazonaws.com/storytape-prod-static/fbb61ca3-d8aa-4333-818a-bf881348525b/sequence_8e718f8c-6f5c-464f-bb9a-5ed6c23d10a8/0003.png",
			"https://s3.amazonaws.com/storytape-prod-static/fbb61ca3-d8aa-4333-818a-bf881348525b/sequence_8e718f8c-6f5c-464f-bb9a-5ed6c23d10a8/0004.png",
			"https://s3.amazonaws.com/storytape-prod-static/fbb61ca3-d8aa-4333-818a-bf881348525b/sequence_8e718f8c-6f5c-464f-bb9a-5ed6c23d10a8/0005.png",
			"https://s3.amazonaws.com/storytape-prod-static/fbb61ca3-d8aa-4333-818a-bf881348525b/sequence_8e718f8c-6f5c-464f-bb9a-5ed6c23d10a8/0006.png",
			"https://s3.amazonaws.com/storytape-prod-static/fbb61ca3-d8aa-4333-818a-bf881348525b/sequence_8e718f8c-6f5c-464f-bb9a-5ed6c23d10a8/0007.png",
			"https://s3.amazonaws.com/storytape-prod-static/fbb61ca3-d8aa-4333-818a-bf881348525b/sequence_8e718f8c-6f5c-464f-bb9a-5ed6c23d10a8/0008.png",
			"https://s3.amazonaws.com/storytape-prod-static/fbb61ca3-d8aa-4333-818a-bf881348525b/sequence_8e718f8c-6f5c-464f-bb9a-5ed6c23d10a8/0009.png",
			"https://s3.amazonaws.com/storytape-prod-static/fbb61ca3-d8aa-4333-818a-bf881348525b/sequence_8e718f8c-6f5c-464f-bb9a-5ed6c23d10a8/0010.png",
			"https://s3.amazonaws.com/storytape-prod-static/fbb61ca3-d8aa-4333-818a-bf881348525b/sequence_8e718f8c-6f5c-464f-bb9a-5ed6c23d10a8/0011.png",
			"https://s3.amazonaws.com/storytape-prod-static/fbb61ca3-d8aa-4333-818a-bf881348525b/sequence_8e718f8c-6f5c-464f-bb9a-5ed6c23d10a8/0012.png",
			"https://s3.amazonaws.com/storytape-prod-static/fbb61ca3-d8aa-4333-818a-bf881348525b/sequence_8e718f8c-6f5c-464f-bb9a-5ed6c23d10a8/0013.png",
			"https://s3.amazonaws.com/storytape-prod-static/fbb61ca3-d8aa-4333-818a-bf881348525b/sequence_8e718f8c-6f5c-464f-bb9a-5ed6c23d10a8/0014.png",
			"https://s3.amazonaws.com/storytape-prod-static/fbb61ca3-d8aa-4333-818a-bf881348525b/sequence_8e718f8c-6f5c-464f-bb9a-5ed6c23d10a8/0015.png",
			"https://s3.amazonaws.com/storytape-prod-static/fbb61ca3-d8aa-4333-818a-bf881348525b/sequence_8e718f8c-6f5c-464f-bb9a-5ed6c23d10a8/0016.png",
			"https://s3.amazonaws.com/storytape-prod-static/fbb61ca3-d8aa-4333-818a-bf881348525b/sequence_8e718f8c-6f5c-464f-bb9a-5ed6c23d10a8/0017.png",
			"https://s3.amazonaws.com/storytape-prod-static/fbb61ca3-d8aa-4333-818a-bf881348525b/sequence_8e718f8c-6f5c-464f-bb9a-5ed6c23d10a8/0018.png",
			"https://s3.amazonaws.com/storytape-prod-static/fbb61ca3-d8aa-4333-818a-bf881348525b/sequence_8e718f8c-6f5c-464f-bb9a-5ed6c23d10a8/0019.png",
			"https://s3.amazonaws.com/storytape-prod-static/fbb61ca3-d8aa-4333-818a-bf881348525b/sequence_8e718f8c-6f5c-464f-bb9a-5ed6c23d10a8/0020.png",
			"https://s3.amazonaws.com/storytape-prod-static/fbb61ca3-d8aa-4333-818a-bf881348525b/sequence_8e718f8c-6f5c-464f-bb9a-5ed6c23d10a8/0021.png",
			"https://s3.amazonaws.com/storytape-prod-static/fbb61ca3-d8aa-4333-818a-bf881348525b/sequence_8e718f8c-6f5c-464f-bb9a-5ed6c23d10a8/0022.png",
			"https://s3.amazonaws.com/storytape-prod-static/fbb61ca3-d8aa-4333-818a-bf881348525b/sequence_8e718f8c-6f5c-464f-bb9a-5ed6c23d10a8/0023.png",
			"https://s3.amazonaws.com/storytape-prod-static/fbb61ca3-d8aa-4333-818a-bf881348525b/sequence_8e718f8c-6f5c-464f-bb9a-5ed6c23d10a8/0024.png",
			"https://s3.amazonaws.com/storytape-prod-static/fbb61ca3-d8aa-4333-818a-bf881348525b/sequence_8e718f8c-6f5c-464f-bb9a-5ed6c23d10a8/0025.png",
			"https://s3.amazonaws.com/storytape-prod-static/fbb61ca3-d8aa-4333-818a-bf881348525b/sequence_8e718f8c-6f5c-464f-bb9a-5ed6c23d10a8/0026.png",
			"https://s3.amazonaws.com/storytape-prod-static/fbb61ca3-d8aa-4333-818a-bf881348525b/sequence_8e718f8c-6f5c-464f-bb9a-5ed6c23d10a8/0027.png",
			"https://s3.amazonaws.com/storytape-prod-static/fbb61ca3-d8aa-4333-818a-bf881348525b/sequence_8e718f8c-6f5c-464f-bb9a-5ed6c23d10a8/0028.png",
			"https://s3.amazonaws.com/storytape-prod-static/fbb61ca3-d8aa-4333-818a-bf881348525b/sequence_8e718f8c-6f5c-464f-bb9a-5ed6c23d10a8/0029.png",
			"https://s3.amazonaws.com/storytape-prod-static/fbb61ca3-d8aa-4333-818a-bf881348525b/sequence_8e718f8c-6f5c-464f-bb9a-5ed6c23d10a8/0030.png",
			"https://s3.amazonaws.com/storytape-prod-static/fbb61ca3-d8aa-4333-818a-bf881348525b/sequence_8e718f8c-6f5c-464f-bb9a-5ed6c23d10a8/0031.png",
			"https://s3.amazonaws.com/storytape-prod-static/fbb61ca3-d8aa-4333-818a-bf881348525b/sequence_8e718f8c-6f5c-464f-bb9a-5ed6c23d10a8/0032.png",
			"https://s3.amazonaws.com/storytape-prod-static/fbb61ca3-d8aa-4333-818a-bf881348525b/sequence_8e718f8c-6f5c-464f-bb9a-5ed6c23d10a8/0033.png",
			"https://s3.amazonaws.com/storytape-prod-static/fbb61ca3-d8aa-4333-818a-bf881348525b/sequence_8e718f8c-6f5c-464f-bb9a-5ed6c23d10a8/0034.png",
			"https://s3.amazonaws.com/storytape-prod-static/fbb61ca3-d8aa-4333-818a-bf881348525b/sequence_8e718f8c-6f5c-464f-bb9a-5ed6c23d10a8/0035.png",
			"https://s3.amazonaws.com/storytape-prod-static/fbb61ca3-d8aa-4333-818a-bf881348525b/sequence_8e718f8c-6f5c-464f-bb9a-5ed6c23d10a8/0036.png",
			"https://s3.amazonaws.com/storytape-prod-static/fbb61ca3-d8aa-4333-818a-bf881348525b/sequence_8e718f8c-6f5c-464f-bb9a-5ed6c23d10a8/0037.png",
			"https://s3.amazonaws.com/storytape-prod-static/fbb61ca3-d8aa-4333-818a-bf881348525b/sequence_8e718f8c-6f5c-464f-bb9a-5ed6c23d10a8/0038.png",
			"https://s3.amazonaws.com/storytape-prod-static/fbb61ca3-d8aa-4333-818a-bf881348525b/sequence_8e718f8c-6f5c-464f-bb9a-5ed6c23d10a8/0039.png",
			"https://s3.amazonaws.com/storytape-prod-static/fbb61ca3-d8aa-4333-818a-bf881348525b/sequence_8e718f8c-6f5c-464f-bb9a-5ed6c23d10a8/0040.png"
		],
		"keywords": [
			"100",
			"american",
			"ashes",
			"backdrop",
			"bank",
			"banking",
			"bill",
			"black",
			"bond",
			"bucks",
			"bundle",
			"burning",
			"business",
			"cash",
			"close-up",
			"currency",
			"current",
			"dollar",
			"expenses",
			"fall",
			"fast",
			"finance",
			"financial",
			"franklin",
			"green",
			"greenback",
			"group",
			"hundred",
			"jackpot",
			"loan",
			"many",
			"money",
			"motion",
			"note",
			"pay",
			"pile",
			"rain",
			"salary",
			"slow",
			"stock",
			"stream",
			"usa",
			"wages",
			"waste",
			"wealth"
		],
		"clip_slug": "money-falling-from-the-sky",
		"clip_poster": "https://s3.amazonaws.com/storytape-prod-static/fbb61ca3-d8aa-4333-818a-bf881348525b/poster_0000_7d1afc25-598c-4eb4-a917-b7bea3434bb1.png",
		"clip_preview_large": "https://s3.amazonaws.com/storytape-prod-static/fbb61ca3-d8aa-4333-818a-bf881348525b/preview-large-a1b43392-1110-46ce-873c-8fdf53ca78da.mp4",
		"clip_length": 20000,
		"scene_description": "Stacks on stacks on stacks of cash. American bills are tossed, flipped through, and burned in a black and white retro themed scene.",
		"clip_thumbnail": "https://s3.amazonaws.com/storytape-prod-static/fbb61ca3-d8aa-4333-818a-bf881348525b/thumbnail_0000_ef2cfcec-d3e8-44f6-acca-19289016ea82.png",
		"clip_name": "Money falling from the sky",
		"scene_thumbnail": "https://s3.amazonaws.com/storytape-prod-static/scene_3b8a9c7b-3847-477e-bb01-73350e86ca81/thumbnail_8850ebae-47ae-4d4c-9285-be52259fd739.jpg",
		"clip_preview_small": "https://s3.amazonaws.com/storytape-prod-static/fbb61ca3-d8aa-4333-818a-bf881348525b/preview-small-9e89d6b8-909e-4f25-9319-955e8f0e5984.mp4",
		"tags": [
			4300,
			4200,
			2400,
			2200,
			3800,
			400,
			1900,
			100
		],
		"featured_at": "2017-11-14T07:09:49.761Z",
		"clip_lqip": "https://s3.amazonaws.com/storytape-prod-static/scene_fbb61ca3-d8aa-4333-818a-bf881348525b/lqip_77be2bb1-6ce5-43d7-9b96-71cf5fc130b9.jpg",
		"scene_poster": "https://s3.amazonaws.com/storytape-prod-static/scene_3b8a9c7b-3847-477e-bb01-73350e86ca81/poster_20377d78-e2ba-4430-8cff-c2ca540d403e.jpg",
		"scene_slug": "cash-money",
		"clip_colors": {
			"Vibrant": "#7f4cb2",
			"DarkVibrant": "#140c1c",
			"Muted": "#7c7860",
			"LightMuted": "#929092",
			"DarkMuted": "#140c14"
		},
		"scene_colors": {
			"Vibrant": "#888428",
			"DarkVibrant": "#207c80",
			"Muted": "#7c7c7c",
			"LightMuted": "#afafaf",
			"DarkMuted": "#444444"
		},
		"scene_name": "Cash Money",
		"scene_id": "3b8a9c7b-3847-477e-bb01-73350e86ca81"
	},
	{
		"clip_id": "d990ce33-247c-450e-8789-7972e1f4e084",
		"scene_lqip": "https://s3.amazonaws.com/storytape-prod-static/scene_fb843602-97f9-4422-8ab4-48ec39687de0/lqip_58d804f2-d2a5-4814-9944-235b4a3d5c8e.jpg",
		"scene_clip_count": "24",
		"published_at": "2017-10-11T14:03:57.491Z",
		"clip_sequence": [
			"https://s3.amazonaws.com/storytape-prod-static/d990ce33-247c-450e-8789-7972e1f4e084/sequence_43e80913-0b07-4314-95d3-bf86c83230f9/0000.png",
			"https://s3.amazonaws.com/storytape-prod-static/d990ce33-247c-450e-8789-7972e1f4e084/sequence_43e80913-0b07-4314-95d3-bf86c83230f9/0001.png",
			"https://s3.amazonaws.com/storytape-prod-static/d990ce33-247c-450e-8789-7972e1f4e084/sequence_43e80913-0b07-4314-95d3-bf86c83230f9/0002.png",
			"https://s3.amazonaws.com/storytape-prod-static/d990ce33-247c-450e-8789-7972e1f4e084/sequence_43e80913-0b07-4314-95d3-bf86c83230f9/0003.png",
			"https://s3.amazonaws.com/storytape-prod-static/d990ce33-247c-450e-8789-7972e1f4e084/sequence_43e80913-0b07-4314-95d3-bf86c83230f9/0004.png",
			"https://s3.amazonaws.com/storytape-prod-static/d990ce33-247c-450e-8789-7972e1f4e084/sequence_43e80913-0b07-4314-95d3-bf86c83230f9/0005.png",
			"https://s3.amazonaws.com/storytape-prod-static/d990ce33-247c-450e-8789-7972e1f4e084/sequence_43e80913-0b07-4314-95d3-bf86c83230f9/0006.png",
			"https://s3.amazonaws.com/storytape-prod-static/d990ce33-247c-450e-8789-7972e1f4e084/sequence_43e80913-0b07-4314-95d3-bf86c83230f9/0007.png",
			"https://s3.amazonaws.com/storytape-prod-static/d990ce33-247c-450e-8789-7972e1f4e084/sequence_43e80913-0b07-4314-95d3-bf86c83230f9/0008.png",
			"https://s3.amazonaws.com/storytape-prod-static/d990ce33-247c-450e-8789-7972e1f4e084/sequence_43e80913-0b07-4314-95d3-bf86c83230f9/0009.png",
			"https://s3.amazonaws.com/storytape-prod-static/d990ce33-247c-450e-8789-7972e1f4e084/sequence_43e80913-0b07-4314-95d3-bf86c83230f9/0010.png",
			"https://s3.amazonaws.com/storytape-prod-static/d990ce33-247c-450e-8789-7972e1f4e084/sequence_43e80913-0b07-4314-95d3-bf86c83230f9/0011.png",
			"https://s3.amazonaws.com/storytape-prod-static/d990ce33-247c-450e-8789-7972e1f4e084/sequence_43e80913-0b07-4314-95d3-bf86c83230f9/0012.png",
			"https://s3.amazonaws.com/storytape-prod-static/d990ce33-247c-450e-8789-7972e1f4e084/sequence_43e80913-0b07-4314-95d3-bf86c83230f9/0013.png",
			"https://s3.amazonaws.com/storytape-prod-static/d990ce33-247c-450e-8789-7972e1f4e084/sequence_43e80913-0b07-4314-95d3-bf86c83230f9/0014.png",
			"https://s3.amazonaws.com/storytape-prod-static/d990ce33-247c-450e-8789-7972e1f4e084/sequence_43e80913-0b07-4314-95d3-bf86c83230f9/0015.png",
			"https://s3.amazonaws.com/storytape-prod-static/d990ce33-247c-450e-8789-7972e1f4e084/sequence_43e80913-0b07-4314-95d3-bf86c83230f9/0016.png",
			"https://s3.amazonaws.com/storytape-prod-static/d990ce33-247c-450e-8789-7972e1f4e084/sequence_43e80913-0b07-4314-95d3-bf86c83230f9/0017.png",
			"https://s3.amazonaws.com/storytape-prod-static/d990ce33-247c-450e-8789-7972e1f4e084/sequence_43e80913-0b07-4314-95d3-bf86c83230f9/0018.png",
			"https://s3.amazonaws.com/storytape-prod-static/d990ce33-247c-450e-8789-7972e1f4e084/sequence_43e80913-0b07-4314-95d3-bf86c83230f9/0019.png",
			"https://s3.amazonaws.com/storytape-prod-static/d990ce33-247c-450e-8789-7972e1f4e084/sequence_43e80913-0b07-4314-95d3-bf86c83230f9/0020.png",
			"https://s3.amazonaws.com/storytape-prod-static/d990ce33-247c-450e-8789-7972e1f4e084/sequence_43e80913-0b07-4314-95d3-bf86c83230f9/0021.png",
			"https://s3.amazonaws.com/storytape-prod-static/d990ce33-247c-450e-8789-7972e1f4e084/sequence_43e80913-0b07-4314-95d3-bf86c83230f9/0022.png",
			"https://s3.amazonaws.com/storytape-prod-static/d990ce33-247c-450e-8789-7972e1f4e084/sequence_43e80913-0b07-4314-95d3-bf86c83230f9/0023.png",
			"https://s3.amazonaws.com/storytape-prod-static/d990ce33-247c-450e-8789-7972e1f4e084/sequence_43e80913-0b07-4314-95d3-bf86c83230f9/0024.png",
			"https://s3.amazonaws.com/storytape-prod-static/d990ce33-247c-450e-8789-7972e1f4e084/sequence_43e80913-0b07-4314-95d3-bf86c83230f9/0025.png",
			"https://s3.amazonaws.com/storytape-prod-static/d990ce33-247c-450e-8789-7972e1f4e084/sequence_43e80913-0b07-4314-95d3-bf86c83230f9/0026.png",
			"https://s3.amazonaws.com/storytape-prod-static/d990ce33-247c-450e-8789-7972e1f4e084/sequence_43e80913-0b07-4314-95d3-bf86c83230f9/0027.png",
			"https://s3.amazonaws.com/storytape-prod-static/d990ce33-247c-450e-8789-7972e1f4e084/sequence_43e80913-0b07-4314-95d3-bf86c83230f9/0028.png",
			"https://s3.amazonaws.com/storytape-prod-static/d990ce33-247c-450e-8789-7972e1f4e084/sequence_43e80913-0b07-4314-95d3-bf86c83230f9/0029.png",
			"https://s3.amazonaws.com/storytape-prod-static/d990ce33-247c-450e-8789-7972e1f4e084/sequence_43e80913-0b07-4314-95d3-bf86c83230f9/0030.png",
			"https://s3.amazonaws.com/storytape-prod-static/d990ce33-247c-450e-8789-7972e1f4e084/sequence_43e80913-0b07-4314-95d3-bf86c83230f9/0031.png",
			"https://s3.amazonaws.com/storytape-prod-static/d990ce33-247c-450e-8789-7972e1f4e084/sequence_43e80913-0b07-4314-95d3-bf86c83230f9/0032.png",
			"https://s3.amazonaws.com/storytape-prod-static/d990ce33-247c-450e-8789-7972e1f4e084/sequence_43e80913-0b07-4314-95d3-bf86c83230f9/0033.png",
			"https://s3.amazonaws.com/storytape-prod-static/d990ce33-247c-450e-8789-7972e1f4e084/sequence_43e80913-0b07-4314-95d3-bf86c83230f9/0034.png",
			"https://s3.amazonaws.com/storytape-prod-static/d990ce33-247c-450e-8789-7972e1f4e084/sequence_43e80913-0b07-4314-95d3-bf86c83230f9/0035.png",
			"https://s3.amazonaws.com/storytape-prod-static/d990ce33-247c-450e-8789-7972e1f4e084/sequence_43e80913-0b07-4314-95d3-bf86c83230f9/0036.png",
			"https://s3.amazonaws.com/storytape-prod-static/d990ce33-247c-450e-8789-7972e1f4e084/sequence_43e80913-0b07-4314-95d3-bf86c83230f9/0037.png",
			"https://s3.amazonaws.com/storytape-prod-static/d990ce33-247c-450e-8789-7972e1f4e084/sequence_43e80913-0b07-4314-95d3-bf86c83230f9/0038.png",
			"https://s3.amazonaws.com/storytape-prod-static/d990ce33-247c-450e-8789-7972e1f4e084/sequence_43e80913-0b07-4314-95d3-bf86c83230f9/0039.png",
			"https://s3.amazonaws.com/storytape-prod-static/d990ce33-247c-450e-8789-7972e1f4e084/sequence_43e80913-0b07-4314-95d3-bf86c83230f9/0040.png"
		],
		"keywords": [
			"abstract",
			"background",
			"beautiful",
			"blue",
			"breathtaking",
			"bubbles",
			"color",
			"cool",
			"crystal",
			"dark",
			"design",
			"floating",
			"flow",
			"geometry",
			"graphics",
			"hexagon",
			"ice",
			"ink",
			"macro",
			"micro",
			"motion",
			"motion graphics",
			"paraffin",
			"science",
			"sequence",
			"shapes",
			"soap",
			"structure",
			"texture",
			"water"
		],
		"clip_slug": "light-and-dark-bubbles-splitting-in-half",
		"clip_poster": "https://s3.amazonaws.com/storytape-prod-static/d990ce33-247c-450e-8789-7972e1f4e084/poster_0000_b0425e8c-cae3-4e33-b8c4-eefbf6ea199a.png",
		"clip_preview_large": "https://s3.amazonaws.com/storytape-prod-static/d990ce33-247c-450e-8789-7972e1f4e084/preview-large-4e6d9a86-156b-45e6-9cb7-156997bb7018.mp4",
		"clip_length": 20000,
		"scene_description": "Combining a mixture of soap and food coloring, these bubbles form diverse polygonal shapes to fill a variety of abstract footage needs.",
		"clip_thumbnail": "https://s3.amazonaws.com/storytape-prod-static/d990ce33-247c-450e-8789-7972e1f4e084/thumbnail_0000_f7e1a1d6-29b1-4469-85fc-510e57623639.png",
		"clip_name": "Light and dark bubbles splitting in half",
		"scene_thumbnail": "https://s3.amazonaws.com/storytape-prod-static/scene_fb843602-97f9-4422-8ab4-48ec39687de0/thumbnail_caa7d55f-b93a-4893-9c1c-797ce7928bd3.jpg",
		"clip_preview_small": "https://s3.amazonaws.com/storytape-prod-static/d990ce33-247c-450e-8789-7972e1f4e084/preview-small-729f5120-346a-48a4-a36a-3100c432dcd4.mp4",
		"tags": [
			4400,
			2600,
			2300,
			3900,
			2200,
			4000,
			1900,
			100
		],
		"clip_lqip": "https://s3.amazonaws.com/storytape-prod-static/scene_d990ce33-247c-450e-8789-7972e1f4e084/lqip_351cf3ed-feb5-4bd8-9b8e-87907e7b1b36.jpg",
		"scene_poster": "https://s3.amazonaws.com/storytape-prod-static/scene_fb843602-97f9-4422-8ab4-48ec39687de0/poster_6c65ef40-549a-4da8-b619-9fa75ac766eb.jpg",
		"scene_slug": "abstract-inky-foam",
		"clip_colors": {
			"Vibrant": "#3c667d",
			"LightVibrant": "#b1cadc",
			"DarkVibrant": "#274552",
			"Muted": "#4a7284",
			"LightMuted": "#a8c2d1",
			"DarkMuted": "#2f4f60"
		},
		"scene_colors": {
			"Vibrant": "#6295b4",
			"LightVibrant": "#7caccc",
			"DarkVibrant": "#2d5162",
			"Muted": "#538097",
			"LightMuted": "#a2c4d1",
			"DarkMuted": "#25444b"
		},
		"scene_name": "Abstract Inky Foam",
		"scene_id": "fb843602-97f9-4422-8ab4-48ec39687de0"
	},
	{
		"clip_id": "e5e85418-1761-4aae-87e6-e8b1c0189bff",
		"scene_lqip": "https://s3.amazonaws.com/storytape-prod-static/scene_476dd1e6-992e-448c-afdd-ca2383fa15b1/lqip_72bd7a5e-cb7c-4700-a9b3-a2b976f1a4c0.jpg",
		"scene_clip_count": "12",
		"published_at": "2017-09-22T06:00:47.929Z",
		"clip_sequence": [
			"https://s3.amazonaws.com/storytape-prod-static/e5e85418-1761-4aae-87e6-e8b1c0189bff/sequence_eadeed0d-0b6d-4ce1-a8c7-0d298eb7a9b6/0000.png",
			"https://s3.amazonaws.com/storytape-prod-static/e5e85418-1761-4aae-87e6-e8b1c0189bff/sequence_eadeed0d-0b6d-4ce1-a8c7-0d298eb7a9b6/0001.png",
			"https://s3.amazonaws.com/storytape-prod-static/e5e85418-1761-4aae-87e6-e8b1c0189bff/sequence_eadeed0d-0b6d-4ce1-a8c7-0d298eb7a9b6/0002.png",
			"https://s3.amazonaws.com/storytape-prod-static/e5e85418-1761-4aae-87e6-e8b1c0189bff/sequence_eadeed0d-0b6d-4ce1-a8c7-0d298eb7a9b6/0003.png",
			"https://s3.amazonaws.com/storytape-prod-static/e5e85418-1761-4aae-87e6-e8b1c0189bff/sequence_eadeed0d-0b6d-4ce1-a8c7-0d298eb7a9b6/0004.png",
			"https://s3.amazonaws.com/storytape-prod-static/e5e85418-1761-4aae-87e6-e8b1c0189bff/sequence_eadeed0d-0b6d-4ce1-a8c7-0d298eb7a9b6/0005.png",
			"https://s3.amazonaws.com/storytape-prod-static/e5e85418-1761-4aae-87e6-e8b1c0189bff/sequence_eadeed0d-0b6d-4ce1-a8c7-0d298eb7a9b6/0006.png",
			"https://s3.amazonaws.com/storytape-prod-static/e5e85418-1761-4aae-87e6-e8b1c0189bff/sequence_eadeed0d-0b6d-4ce1-a8c7-0d298eb7a9b6/0007.png",
			"https://s3.amazonaws.com/storytape-prod-static/e5e85418-1761-4aae-87e6-e8b1c0189bff/sequence_eadeed0d-0b6d-4ce1-a8c7-0d298eb7a9b6/0008.png",
			"https://s3.amazonaws.com/storytape-prod-static/e5e85418-1761-4aae-87e6-e8b1c0189bff/sequence_eadeed0d-0b6d-4ce1-a8c7-0d298eb7a9b6/0009.png",
			"https://s3.amazonaws.com/storytape-prod-static/e5e85418-1761-4aae-87e6-e8b1c0189bff/sequence_eadeed0d-0b6d-4ce1-a8c7-0d298eb7a9b6/0010.png",
			"https://s3.amazonaws.com/storytape-prod-static/e5e85418-1761-4aae-87e6-e8b1c0189bff/sequence_eadeed0d-0b6d-4ce1-a8c7-0d298eb7a9b6/0011.png",
			"https://s3.amazonaws.com/storytape-prod-static/e5e85418-1761-4aae-87e6-e8b1c0189bff/sequence_eadeed0d-0b6d-4ce1-a8c7-0d298eb7a9b6/0012.png",
			"https://s3.amazonaws.com/storytape-prod-static/e5e85418-1761-4aae-87e6-e8b1c0189bff/sequence_eadeed0d-0b6d-4ce1-a8c7-0d298eb7a9b6/0013.png",
			"https://s3.amazonaws.com/storytape-prod-static/e5e85418-1761-4aae-87e6-e8b1c0189bff/sequence_eadeed0d-0b6d-4ce1-a8c7-0d298eb7a9b6/0014.png",
			"https://s3.amazonaws.com/storytape-prod-static/e5e85418-1761-4aae-87e6-e8b1c0189bff/sequence_eadeed0d-0b6d-4ce1-a8c7-0d298eb7a9b6/0015.png",
			"https://s3.amazonaws.com/storytape-prod-static/e5e85418-1761-4aae-87e6-e8b1c0189bff/sequence_eadeed0d-0b6d-4ce1-a8c7-0d298eb7a9b6/0016.png",
			"https://s3.amazonaws.com/storytape-prod-static/e5e85418-1761-4aae-87e6-e8b1c0189bff/sequence_eadeed0d-0b6d-4ce1-a8c7-0d298eb7a9b6/0017.png",
			"https://s3.amazonaws.com/storytape-prod-static/e5e85418-1761-4aae-87e6-e8b1c0189bff/sequence_eadeed0d-0b6d-4ce1-a8c7-0d298eb7a9b6/0018.png",
			"https://s3.amazonaws.com/storytape-prod-static/e5e85418-1761-4aae-87e6-e8b1c0189bff/sequence_eadeed0d-0b6d-4ce1-a8c7-0d298eb7a9b6/0019.png",
			"https://s3.amazonaws.com/storytape-prod-static/e5e85418-1761-4aae-87e6-e8b1c0189bff/sequence_eadeed0d-0b6d-4ce1-a8c7-0d298eb7a9b6/0020.png",
			"https://s3.amazonaws.com/storytape-prod-static/e5e85418-1761-4aae-87e6-e8b1c0189bff/sequence_eadeed0d-0b6d-4ce1-a8c7-0d298eb7a9b6/0021.png",
			"https://s3.amazonaws.com/storytape-prod-static/e5e85418-1761-4aae-87e6-e8b1c0189bff/sequence_eadeed0d-0b6d-4ce1-a8c7-0d298eb7a9b6/0022.png",
			"https://s3.amazonaws.com/storytape-prod-static/e5e85418-1761-4aae-87e6-e8b1c0189bff/sequence_eadeed0d-0b6d-4ce1-a8c7-0d298eb7a9b6/0023.png",
			"https://s3.amazonaws.com/storytape-prod-static/e5e85418-1761-4aae-87e6-e8b1c0189bff/sequence_eadeed0d-0b6d-4ce1-a8c7-0d298eb7a9b6/0024.png",
			"https://s3.amazonaws.com/storytape-prod-static/e5e85418-1761-4aae-87e6-e8b1c0189bff/sequence_eadeed0d-0b6d-4ce1-a8c7-0d298eb7a9b6/0025.png",
			"https://s3.amazonaws.com/storytape-prod-static/e5e85418-1761-4aae-87e6-e8b1c0189bff/sequence_eadeed0d-0b6d-4ce1-a8c7-0d298eb7a9b6/0026.png",
			"https://s3.amazonaws.com/storytape-prod-static/e5e85418-1761-4aae-87e6-e8b1c0189bff/sequence_eadeed0d-0b6d-4ce1-a8c7-0d298eb7a9b6/0027.png",
			"https://s3.amazonaws.com/storytape-prod-static/e5e85418-1761-4aae-87e6-e8b1c0189bff/sequence_eadeed0d-0b6d-4ce1-a8c7-0d298eb7a9b6/0028.png",
			"https://s3.amazonaws.com/storytape-prod-static/e5e85418-1761-4aae-87e6-e8b1c0189bff/sequence_eadeed0d-0b6d-4ce1-a8c7-0d298eb7a9b6/0029.png",
			"https://s3.amazonaws.com/storytape-prod-static/e5e85418-1761-4aae-87e6-e8b1c0189bff/sequence_eadeed0d-0b6d-4ce1-a8c7-0d298eb7a9b6/0030.png",
			"https://s3.amazonaws.com/storytape-prod-static/e5e85418-1761-4aae-87e6-e8b1c0189bff/sequence_eadeed0d-0b6d-4ce1-a8c7-0d298eb7a9b6/0031.png",
			"https://s3.amazonaws.com/storytape-prod-static/e5e85418-1761-4aae-87e6-e8b1c0189bff/sequence_eadeed0d-0b6d-4ce1-a8c7-0d298eb7a9b6/0032.png",
			"https://s3.amazonaws.com/storytape-prod-static/e5e85418-1761-4aae-87e6-e8b1c0189bff/sequence_eadeed0d-0b6d-4ce1-a8c7-0d298eb7a9b6/0033.png",
			"https://s3.amazonaws.com/storytape-prod-static/e5e85418-1761-4aae-87e6-e8b1c0189bff/sequence_eadeed0d-0b6d-4ce1-a8c7-0d298eb7a9b6/0034.png",
			"https://s3.amazonaws.com/storytape-prod-static/e5e85418-1761-4aae-87e6-e8b1c0189bff/sequence_eadeed0d-0b6d-4ce1-a8c7-0d298eb7a9b6/0035.png",
			"https://s3.amazonaws.com/storytape-prod-static/e5e85418-1761-4aae-87e6-e8b1c0189bff/sequence_eadeed0d-0b6d-4ce1-a8c7-0d298eb7a9b6/0036.png",
			"https://s3.amazonaws.com/storytape-prod-static/e5e85418-1761-4aae-87e6-e8b1c0189bff/sequence_eadeed0d-0b6d-4ce1-a8c7-0d298eb7a9b6/0037.png"
		],
		"keywords": [
			"crater",
			"desert",
			"dreamscape",
			"dry",
			"green",
			"highlands",
			"hilly",
			"iceland",
			"icelandic",
			"landscape",
			"majestic",
			"mountain",
			"nature",
			"nordic",
			"polar",
			"river",
			"rock",
			"sand",
			"scenery",
			"scenic",
			"sky",
			"tourism",
			"touristic",
			"travel",
			"trip",
			"unbelievable",
			"unreal",
			"valley",
			"volcanic",
			"volcano",
			"wilderness"
		],
		"clip_slug": "red-and-green-crater-in-mountainous-terrain",
		"clip_poster": "https://s3.amazonaws.com/storytape-prod-static/e5e85418-1761-4aae-87e6-e8b1c0189bff/poster_0000_9d717672-d9bd-4f95-bda0-52dd29600617.png",
		"clip_preview_large": "https://s3.amazonaws.com/storytape-prod-static/e5e85418-1761-4aae-87e6-e8b1c0189bff/preview-large-1ff33ed4-b05f-4030-ae9b-f82c3351f805.mp4",
		"clip_length": 18750,
		"scene_description": "The Secret Life of Walter Mitty didn't get to explore this volcanic mountain range. Enjoy footage from one of Iceland's many volcanoes and the rocky landscape that surrounds it under the setting sun.",
		"clip_thumbnail": "https://s3.amazonaws.com/storytape-prod-static/e5e85418-1761-4aae-87e6-e8b1c0189bff/thumbnail_0000_04c3a705-0ffd-47d5-a1d3-14f0e858f386.png",
		"clip_name": "Red and green crater in mountainous terrain",
		"scene_thumbnail": "https://s3.amazonaws.com/storytape-prod-static/scene_476dd1e6-992e-448c-afdd-ca2383fa15b1/thumbnail_a2be0b1f-cd1b-4411-9a1f-4dfaf9e5aa42.jpg",
		"clip_preview_small": "https://s3.amazonaws.com/storytape-prod-static/e5e85418-1761-4aae-87e6-e8b1c0189bff/preview-small-1d611fdb-a1c3-4a03-aba8-4d8f0aa1404e.mp4",
		"tags": [
			1100,
			2700,
			4300,
			4200,
			900,
			2400,
			2100,
			3000,
			3600,
			200,
			3400
		],
		"clip_lqip": "https://s3.amazonaws.com/storytape-prod-static/scene_e5e85418-1761-4aae-87e6-e8b1c0189bff/lqip_4e961e79-8704-4322-9bc9-fa49bf3b7ba9.jpg",
		"scene_poster": "https://s3.amazonaws.com/storytape-prod-static/scene_476dd1e6-992e-448c-afdd-ca2383fa15b1/poster_fe34ccbc-c0aa-4b5a-af47-4f37f0ca93d5.jpg",
		"scene_slug": "volcanic-mountain-range",
		"clip_colors": {
			"Vibrant": "#ac8e52",
			"DarkVibrant": "#5c4c2c",
			"Muted": "#71788e",
			"LightMuted": "#c8ccda",
			"DarkMuted": "#625239"
		},
		"scene_colors": {
			"Vibrant": "#ac9052",
			"DarkVibrant": "#5c4d2c",
			"Muted": "#8c7552",
			"LightMuted": "#cad0db",
			"DarkMuted": "#61523a"
		},
		"scene_name": "Volcanic Mountain Range",
		"scene_id": "476dd1e6-992e-448c-afdd-ca2383fa15b1"
	},
	{
		"clip_id": "ffcdd117-c3bc-43d8-a4f1-0dac3212cab6",
		"scene_lqip": "https://s3.amazonaws.com/storytape-prod-static/scene_1c6f06ba-9731-4bef-8878-d04dcff2d1ba/lqip_5f36eb13-dbca-4328-a5e5-03d233c05e21.jpg",
		"scene_clip_count": "59",
		"published_at": "2017-11-03T15:20:08.027Z",
		"clip_sequence": [
			"https://s3.amazonaws.com/storytape-prod-static/ffcdd117-c3bc-43d8-a4f1-0dac3212cab6/sequence_28cc5f70-2f98-468e-ae16-b60b9fdc0676/0000.png",
			"https://s3.amazonaws.com/storytape-prod-static/ffcdd117-c3bc-43d8-a4f1-0dac3212cab6/sequence_28cc5f70-2f98-468e-ae16-b60b9fdc0676/0001.png",
			"https://s3.amazonaws.com/storytape-prod-static/ffcdd117-c3bc-43d8-a4f1-0dac3212cab6/sequence_28cc5f70-2f98-468e-ae16-b60b9fdc0676/0002.png",
			"https://s3.amazonaws.com/storytape-prod-static/ffcdd117-c3bc-43d8-a4f1-0dac3212cab6/sequence_28cc5f70-2f98-468e-ae16-b60b9fdc0676/0003.png",
			"https://s3.amazonaws.com/storytape-prod-static/ffcdd117-c3bc-43d8-a4f1-0dac3212cab6/sequence_28cc5f70-2f98-468e-ae16-b60b9fdc0676/0004.png",
			"https://s3.amazonaws.com/storytape-prod-static/ffcdd117-c3bc-43d8-a4f1-0dac3212cab6/sequence_28cc5f70-2f98-468e-ae16-b60b9fdc0676/0005.png",
			"https://s3.amazonaws.com/storytape-prod-static/ffcdd117-c3bc-43d8-a4f1-0dac3212cab6/sequence_28cc5f70-2f98-468e-ae16-b60b9fdc0676/0006.png",
			"https://s3.amazonaws.com/storytape-prod-static/ffcdd117-c3bc-43d8-a4f1-0dac3212cab6/sequence_28cc5f70-2f98-468e-ae16-b60b9fdc0676/0007.png",
			"https://s3.amazonaws.com/storytape-prod-static/ffcdd117-c3bc-43d8-a4f1-0dac3212cab6/sequence_28cc5f70-2f98-468e-ae16-b60b9fdc0676/0008.png",
			"https://s3.amazonaws.com/storytape-prod-static/ffcdd117-c3bc-43d8-a4f1-0dac3212cab6/sequence_28cc5f70-2f98-468e-ae16-b60b9fdc0676/0009.png",
			"https://s3.amazonaws.com/storytape-prod-static/ffcdd117-c3bc-43d8-a4f1-0dac3212cab6/sequence_28cc5f70-2f98-468e-ae16-b60b9fdc0676/0010.png",
			"https://s3.amazonaws.com/storytape-prod-static/ffcdd117-c3bc-43d8-a4f1-0dac3212cab6/sequence_28cc5f70-2f98-468e-ae16-b60b9fdc0676/0011.png",
			"https://s3.amazonaws.com/storytape-prod-static/ffcdd117-c3bc-43d8-a4f1-0dac3212cab6/sequence_28cc5f70-2f98-468e-ae16-b60b9fdc0676/0012.png",
			"https://s3.amazonaws.com/storytape-prod-static/ffcdd117-c3bc-43d8-a4f1-0dac3212cab6/sequence_28cc5f70-2f98-468e-ae16-b60b9fdc0676/0013.png",
			"https://s3.amazonaws.com/storytape-prod-static/ffcdd117-c3bc-43d8-a4f1-0dac3212cab6/sequence_28cc5f70-2f98-468e-ae16-b60b9fdc0676/0014.png",
			"https://s3.amazonaws.com/storytape-prod-static/ffcdd117-c3bc-43d8-a4f1-0dac3212cab6/sequence_28cc5f70-2f98-468e-ae16-b60b9fdc0676/0015.png",
			"https://s3.amazonaws.com/storytape-prod-static/ffcdd117-c3bc-43d8-a4f1-0dac3212cab6/sequence_28cc5f70-2f98-468e-ae16-b60b9fdc0676/0016.png",
			"https://s3.amazonaws.com/storytape-prod-static/ffcdd117-c3bc-43d8-a4f1-0dac3212cab6/sequence_28cc5f70-2f98-468e-ae16-b60b9fdc0676/0017.png",
			"https://s3.amazonaws.com/storytape-prod-static/ffcdd117-c3bc-43d8-a4f1-0dac3212cab6/sequence_28cc5f70-2f98-468e-ae16-b60b9fdc0676/0018.png",
			"https://s3.amazonaws.com/storytape-prod-static/ffcdd117-c3bc-43d8-a4f1-0dac3212cab6/sequence_28cc5f70-2f98-468e-ae16-b60b9fdc0676/0019.png",
			"https://s3.amazonaws.com/storytape-prod-static/ffcdd117-c3bc-43d8-a4f1-0dac3212cab6/sequence_28cc5f70-2f98-468e-ae16-b60b9fdc0676/0020.png",
			"https://s3.amazonaws.com/storytape-prod-static/ffcdd117-c3bc-43d8-a4f1-0dac3212cab6/sequence_28cc5f70-2f98-468e-ae16-b60b9fdc0676/0021.png",
			"https://s3.amazonaws.com/storytape-prod-static/ffcdd117-c3bc-43d8-a4f1-0dac3212cab6/sequence_28cc5f70-2f98-468e-ae16-b60b9fdc0676/0022.png",
			"https://s3.amazonaws.com/storytape-prod-static/ffcdd117-c3bc-43d8-a4f1-0dac3212cab6/sequence_28cc5f70-2f98-468e-ae16-b60b9fdc0676/0023.png",
			"https://s3.amazonaws.com/storytape-prod-static/ffcdd117-c3bc-43d8-a4f1-0dac3212cab6/sequence_28cc5f70-2f98-468e-ae16-b60b9fdc0676/0024.png",
			"https://s3.amazonaws.com/storytape-prod-static/ffcdd117-c3bc-43d8-a4f1-0dac3212cab6/sequence_28cc5f70-2f98-468e-ae16-b60b9fdc0676/0025.png",
			"https://s3.amazonaws.com/storytape-prod-static/ffcdd117-c3bc-43d8-a4f1-0dac3212cab6/sequence_28cc5f70-2f98-468e-ae16-b60b9fdc0676/0026.png",
			"https://s3.amazonaws.com/storytape-prod-static/ffcdd117-c3bc-43d8-a4f1-0dac3212cab6/sequence_28cc5f70-2f98-468e-ae16-b60b9fdc0676/0027.png",
			"https://s3.amazonaws.com/storytape-prod-static/ffcdd117-c3bc-43d8-a4f1-0dac3212cab6/sequence_28cc5f70-2f98-468e-ae16-b60b9fdc0676/0028.png",
			"https://s3.amazonaws.com/storytape-prod-static/ffcdd117-c3bc-43d8-a4f1-0dac3212cab6/sequence_28cc5f70-2f98-468e-ae16-b60b9fdc0676/0029.png",
			"https://s3.amazonaws.com/storytape-prod-static/ffcdd117-c3bc-43d8-a4f1-0dac3212cab6/sequence_28cc5f70-2f98-468e-ae16-b60b9fdc0676/0030.png",
			"https://s3.amazonaws.com/storytape-prod-static/ffcdd117-c3bc-43d8-a4f1-0dac3212cab6/sequence_28cc5f70-2f98-468e-ae16-b60b9fdc0676/0031.png",
			"https://s3.amazonaws.com/storytape-prod-static/ffcdd117-c3bc-43d8-a4f1-0dac3212cab6/sequence_28cc5f70-2f98-468e-ae16-b60b9fdc0676/0032.png",
			"https://s3.amazonaws.com/storytape-prod-static/ffcdd117-c3bc-43d8-a4f1-0dac3212cab6/sequence_28cc5f70-2f98-468e-ae16-b60b9fdc0676/0033.png",
			"https://s3.amazonaws.com/storytape-prod-static/ffcdd117-c3bc-43d8-a4f1-0dac3212cab6/sequence_28cc5f70-2f98-468e-ae16-b60b9fdc0676/0034.png",
			"https://s3.amazonaws.com/storytape-prod-static/ffcdd117-c3bc-43d8-a4f1-0dac3212cab6/sequence_28cc5f70-2f98-468e-ae16-b60b9fdc0676/0035.png",
			"https://s3.amazonaws.com/storytape-prod-static/ffcdd117-c3bc-43d8-a4f1-0dac3212cab6/sequence_28cc5f70-2f98-468e-ae16-b60b9fdc0676/0036.png",
			"https://s3.amazonaws.com/storytape-prod-static/ffcdd117-c3bc-43d8-a4f1-0dac3212cab6/sequence_28cc5f70-2f98-468e-ae16-b60b9fdc0676/0037.png",
			"https://s3.amazonaws.com/storytape-prod-static/ffcdd117-c3bc-43d8-a4f1-0dac3212cab6/sequence_28cc5f70-2f98-468e-ae16-b60b9fdc0676/0038.png",
			"https://s3.amazonaws.com/storytape-prod-static/ffcdd117-c3bc-43d8-a4f1-0dac3212cab6/sequence_28cc5f70-2f98-468e-ae16-b60b9fdc0676/0039.png",
			"https://s3.amazonaws.com/storytape-prod-static/ffcdd117-c3bc-43d8-a4f1-0dac3212cab6/sequence_28cc5f70-2f98-468e-ae16-b60b9fdc0676/0040.png"
		],
		"keywords": [
			"annual event",
			"background",
			"beautiful",
			"beauty",
			"big",
			"black",
			"bright",
			"burst",
			"celebrate",
			"celebration",
			"closed",
			"colorful",
			"dark",
			"detail",
			"event",
			"explode",
			"explosion",
			"festival",
			"festive",
			"fire",
			"firework",
			"firework display",
			"fun",
			"glowing",
			"holiday",
			"isolated",
			"large",
			"new year's",
			"night",
			"outburst",
			"party",
			"pyrotechnics",
			"real",
			"sky",
			"texture"
		],
		"clip_slug": "fireworks-of-purple-balls-and-golden-streams",
		"clip_poster": "https://s3.amazonaws.com/storytape-prod-static/ffcdd117-c3bc-43d8-a4f1-0dac3212cab6/poster_0000_4158ac89-2ad0-4ecd-849e-cb6fb2d4b0ab.png",
		"clip_preview_large": "https://s3.amazonaws.com/storytape-prod-static/ffcdd117-c3bc-43d8-a4f1-0dac3212cab6/preview-large-713f9337-99a0-4023-8c8f-557b0d80ff84.mp4",
		"clip_length": 20000,
		"scene_description": "CRACK! KA-BOOM! Light flashes and sparkles of confetti fire reign down from the night sky. What better way to celebrate any festival than with the brilliant lights of fireworks?",
		"clip_thumbnail": "https://s3.amazonaws.com/storytape-prod-static/ffcdd117-c3bc-43d8-a4f1-0dac3212cab6/thumbnail_0000_5fac52f8-376f-4f8b-9739-f97b72d3a3a1.png",
		"clip_name": "Fireworks of purple balls and golden streams",
		"scene_thumbnail": "https://s3.amazonaws.com/storytape-prod-static/scene_1c6f06ba-9731-4bef-8878-d04dcff2d1ba/thumbnail_13afb96b-1068-4d23-8f32-bac75e249262.jpg",
		"clip_preview_small": "https://s3.amazonaws.com/storytape-prod-static/ffcdd117-c3bc-43d8-a4f1-0dac3212cab6/preview-small-25641507-68c5-4085-a374-95fd04efca3a.mp4",
		"tags": [
			2900,
			4400,
			2700,
			800,
			2400,
			500,
			4000,
			3600,
			2000,
			3500,
			1000
		],
		"clip_lqip": "https://s3.amazonaws.com/storytape-prod-static/scene_ffcdd117-c3bc-43d8-a4f1-0dac3212cab6/lqip_cc8409cc-31d9-4d60-9fa9-a197e69a60d2.jpg",
		"scene_poster": "https://s3.amazonaws.com/storytape-prod-static/scene_1c6f06ba-9731-4bef-8878-d04dcff2d1ba/poster_18428bf0-f763-44b4-82a1-00b43b67ddbc.jpg",
		"scene_slug": "fireworks",
		"clip_colors": {
			"Vibrant": "#8f2fcf",
			"DarkVibrant": "#240c34",
			"Muted": "#7e6e6e",
			"DarkMuted": "#543c64"
		},
		"scene_colors": {
			"Vibrant": "#8c5e3c",
			"LightVibrant": "#dcb69b",
			"DarkVibrant": "#4c1c64",
			"Muted": "#a68873",
			"LightMuted": "#d4bbab",
			"DarkMuted": "#634937"
		},
		"scene_name": "Fireworks",
		"scene_id": "1c6f06ba-9731-4bef-8878-d04dcff2d1ba"
	},
	{
		"clip_id": "e9b5e009-4ae7-4654-9249-3ed6cace45ca",
		"scene_lqip": "https://s3.amazonaws.com/storytape-prod-static/scene_974d17b4-5848-45c2-8f15-f1d7dbd5a898/lqip_ecc3b2ab-9119-4b69-b768-95101aab5931.jpg",
		"scene_clip_count": "39",
		"published_at": "2017-11-06T19:52:48.56Z",
		"clip_sequence": [
			"https://s3.amazonaws.com/storytape-prod-static/e9b5e009-4ae7-4654-9249-3ed6cace45ca/sequence_4c80e006-6f01-45c5-829a-0699a3f98be0/0000.png",
			"https://s3.amazonaws.com/storytape-prod-static/e9b5e009-4ae7-4654-9249-3ed6cace45ca/sequence_4c80e006-6f01-45c5-829a-0699a3f98be0/0001.png",
			"https://s3.amazonaws.com/storytape-prod-static/e9b5e009-4ae7-4654-9249-3ed6cace45ca/sequence_4c80e006-6f01-45c5-829a-0699a3f98be0/0002.png",
			"https://s3.amazonaws.com/storytape-prod-static/e9b5e009-4ae7-4654-9249-3ed6cace45ca/sequence_4c80e006-6f01-45c5-829a-0699a3f98be0/0003.png",
			"https://s3.amazonaws.com/storytape-prod-static/e9b5e009-4ae7-4654-9249-3ed6cace45ca/sequence_4c80e006-6f01-45c5-829a-0699a3f98be0/0004.png",
			"https://s3.amazonaws.com/storytape-prod-static/e9b5e009-4ae7-4654-9249-3ed6cace45ca/sequence_4c80e006-6f01-45c5-829a-0699a3f98be0/0005.png",
			"https://s3.amazonaws.com/storytape-prod-static/e9b5e009-4ae7-4654-9249-3ed6cace45ca/sequence_4c80e006-6f01-45c5-829a-0699a3f98be0/0006.png",
			"https://s3.amazonaws.com/storytape-prod-static/e9b5e009-4ae7-4654-9249-3ed6cace45ca/sequence_4c80e006-6f01-45c5-829a-0699a3f98be0/0007.png",
			"https://s3.amazonaws.com/storytape-prod-static/e9b5e009-4ae7-4654-9249-3ed6cace45ca/sequence_4c80e006-6f01-45c5-829a-0699a3f98be0/0008.png",
			"https://s3.amazonaws.com/storytape-prod-static/e9b5e009-4ae7-4654-9249-3ed6cace45ca/sequence_4c80e006-6f01-45c5-829a-0699a3f98be0/0009.png",
			"https://s3.amazonaws.com/storytape-prod-static/e9b5e009-4ae7-4654-9249-3ed6cace45ca/sequence_4c80e006-6f01-45c5-829a-0699a3f98be0/0010.png",
			"https://s3.amazonaws.com/storytape-prod-static/e9b5e009-4ae7-4654-9249-3ed6cace45ca/sequence_4c80e006-6f01-45c5-829a-0699a3f98be0/0011.png",
			"https://s3.amazonaws.com/storytape-prod-static/e9b5e009-4ae7-4654-9249-3ed6cace45ca/sequence_4c80e006-6f01-45c5-829a-0699a3f98be0/0012.png",
			"https://s3.amazonaws.com/storytape-prod-static/e9b5e009-4ae7-4654-9249-3ed6cace45ca/sequence_4c80e006-6f01-45c5-829a-0699a3f98be0/0013.png",
			"https://s3.amazonaws.com/storytape-prod-static/e9b5e009-4ae7-4654-9249-3ed6cace45ca/sequence_4c80e006-6f01-45c5-829a-0699a3f98be0/0014.png",
			"https://s3.amazonaws.com/storytape-prod-static/e9b5e009-4ae7-4654-9249-3ed6cace45ca/sequence_4c80e006-6f01-45c5-829a-0699a3f98be0/0015.png",
			"https://s3.amazonaws.com/storytape-prod-static/e9b5e009-4ae7-4654-9249-3ed6cace45ca/sequence_4c80e006-6f01-45c5-829a-0699a3f98be0/0016.png",
			"https://s3.amazonaws.com/storytape-prod-static/e9b5e009-4ae7-4654-9249-3ed6cace45ca/sequence_4c80e006-6f01-45c5-829a-0699a3f98be0/0017.png",
			"https://s3.amazonaws.com/storytape-prod-static/e9b5e009-4ae7-4654-9249-3ed6cace45ca/sequence_4c80e006-6f01-45c5-829a-0699a3f98be0/0018.png",
			"https://s3.amazonaws.com/storytape-prod-static/e9b5e009-4ae7-4654-9249-3ed6cace45ca/sequence_4c80e006-6f01-45c5-829a-0699a3f98be0/0019.png",
			"https://s3.amazonaws.com/storytape-prod-static/e9b5e009-4ae7-4654-9249-3ed6cace45ca/sequence_4c80e006-6f01-45c5-829a-0699a3f98be0/0020.png",
			"https://s3.amazonaws.com/storytape-prod-static/e9b5e009-4ae7-4654-9249-3ed6cace45ca/sequence_4c80e006-6f01-45c5-829a-0699a3f98be0/0021.png",
			"https://s3.amazonaws.com/storytape-prod-static/e9b5e009-4ae7-4654-9249-3ed6cace45ca/sequence_4c80e006-6f01-45c5-829a-0699a3f98be0/0022.png",
			"https://s3.amazonaws.com/storytape-prod-static/e9b5e009-4ae7-4654-9249-3ed6cace45ca/sequence_4c80e006-6f01-45c5-829a-0699a3f98be0/0023.png",
			"https://s3.amazonaws.com/storytape-prod-static/e9b5e009-4ae7-4654-9249-3ed6cace45ca/sequence_4c80e006-6f01-45c5-829a-0699a3f98be0/0024.png",
			"https://s3.amazonaws.com/storytape-prod-static/e9b5e009-4ae7-4654-9249-3ed6cace45ca/sequence_4c80e006-6f01-45c5-829a-0699a3f98be0/0025.png",
			"https://s3.amazonaws.com/storytape-prod-static/e9b5e009-4ae7-4654-9249-3ed6cace45ca/sequence_4c80e006-6f01-45c5-829a-0699a3f98be0/0026.png",
			"https://s3.amazonaws.com/storytape-prod-static/e9b5e009-4ae7-4654-9249-3ed6cace45ca/sequence_4c80e006-6f01-45c5-829a-0699a3f98be0/0027.png",
			"https://s3.amazonaws.com/storytape-prod-static/e9b5e009-4ae7-4654-9249-3ed6cace45ca/sequence_4c80e006-6f01-45c5-829a-0699a3f98be0/0028.png",
			"https://s3.amazonaws.com/storytape-prod-static/e9b5e009-4ae7-4654-9249-3ed6cace45ca/sequence_4c80e006-6f01-45c5-829a-0699a3f98be0/0029.png",
			"https://s3.amazonaws.com/storytape-prod-static/e9b5e009-4ae7-4654-9249-3ed6cace45ca/sequence_4c80e006-6f01-45c5-829a-0699a3f98be0/0030.png",
			"https://s3.amazonaws.com/storytape-prod-static/e9b5e009-4ae7-4654-9249-3ed6cace45ca/sequence_4c80e006-6f01-45c5-829a-0699a3f98be0/0031.png",
			"https://s3.amazonaws.com/storytape-prod-static/e9b5e009-4ae7-4654-9249-3ed6cace45ca/sequence_4c80e006-6f01-45c5-829a-0699a3f98be0/0032.png",
			"https://s3.amazonaws.com/storytape-prod-static/e9b5e009-4ae7-4654-9249-3ed6cace45ca/sequence_4c80e006-6f01-45c5-829a-0699a3f98be0/0033.png",
			"https://s3.amazonaws.com/storytape-prod-static/e9b5e009-4ae7-4654-9249-3ed6cace45ca/sequence_4c80e006-6f01-45c5-829a-0699a3f98be0/0034.png",
			"https://s3.amazonaws.com/storytape-prod-static/e9b5e009-4ae7-4654-9249-3ed6cace45ca/sequence_4c80e006-6f01-45c5-829a-0699a3f98be0/0035.png",
			"https://s3.amazonaws.com/storytape-prod-static/e9b5e009-4ae7-4654-9249-3ed6cace45ca/sequence_4c80e006-6f01-45c5-829a-0699a3f98be0/0036.png",
			"https://s3.amazonaws.com/storytape-prod-static/e9b5e009-4ae7-4654-9249-3ed6cace45ca/sequence_4c80e006-6f01-45c5-829a-0699a3f98be0/0037.png",
			"https://s3.amazonaws.com/storytape-prod-static/e9b5e009-4ae7-4654-9249-3ed6cace45ca/sequence_4c80e006-6f01-45c5-829a-0699a3f98be0/0038.png",
			"https://s3.amazonaws.com/storytape-prod-static/e9b5e009-4ae7-4654-9249-3ed6cace45ca/sequence_4c80e006-6f01-45c5-829a-0699a3f98be0/0039.png",
			"https://s3.amazonaws.com/storytape-prod-static/e9b5e009-4ae7-4654-9249-3ed6cace45ca/sequence_4c80e006-6f01-45c5-829a-0699a3f98be0/0040.png",
			"https://s3.amazonaws.com/storytape-prod-static/e9b5e009-4ae7-4654-9249-3ed6cace45ca/sequence_4c80e006-6f01-45c5-829a-0699a3f98be0/0041.png"
		],
		"keywords": [
			"beach",
			"beautiful",
			"calm",
			"dark",
			"deep",
			"early",
			"flower",
			"grass",
			"great",
			"horizon",
			"lake",
			"morning",
			"niagara",
			"ontario",
			"rock",
			"rural",
			"sand",
			"shore",
			"still",
			"sunrise",
			"water"
		],
		"clip_slug": "first-light-on-a-lake",
		"clip_poster": "https://s3.amazonaws.com/storytape-prod-static/e9b5e009-4ae7-4654-9249-3ed6cace45ca/poster_0000_133bbed7-fc65-44e6-9448-447334a639ee.png",
		"clip_preview_large": "https://s3.amazonaws.com/storytape-prod-static/e9b5e009-4ae7-4654-9249-3ed6cace45ca/preview-large-ed10a79a-c150-4e4b-8c44-4179fe8a78ca.mp4",
		"clip_length": 20667,
		"scene_description": "Reflective. Thoughtful. Serene. This scene encompasses these emotions as a solitary man wakes up early in the morning and spends time on the shores of a peaceful lake as he watches the sunrise.",
		"clip_thumbnail": "https://s3.amazonaws.com/storytape-prod-static/e9b5e009-4ae7-4654-9249-3ed6cace45ca/thumbnail_0000_ee612610-3bba-4b17-b1fc-a8cc14fa28f0.png",
		"clip_name": "First light on a lake",
		"scene_thumbnail": "https://s3.amazonaws.com/storytape-prod-static/scene_974d17b4-5848-45c2-8f15-f1d7dbd5a898/thumbnail_2203ff9d-f774-4f50-b8e9-12a772ab5bd7.jpg",
		"clip_preview_small": "https://s3.amazonaws.com/storytape-prod-static/e9b5e009-4ae7-4654-9249-3ed6cace45ca/preview-small-041f2a42-0ad3-47b9-bbb2-49ad6825b0e7.mp4",
		"tags": [
			2900,
			2700,
			2300,
			2100,
			1800,
			1200,
			1100,
			4300,
			900,
			4000,
			3600,
			1000,
			3200
		],
		"clip_lqip": "https://s3.amazonaws.com/storytape-prod-static/scene_e9b5e009-4ae7-4654-9249-3ed6cace45ca/lqip_387fa72f-b123-497f-97a6-5670d7415827.jpg",
		"scene_poster": "https://s3.amazonaws.com/storytape-prod-static/scene_974d17b4-5848-45c2-8f15-f1d7dbd5a898/poster_6b58e9e1-89ac-483e-a2ab-22e250881a71.jpg",
		"scene_slug": "early-morning-at-the-lake",
		"clip_colors": {
			"Muted": "#535d64",
			"DarkMuted": "#2c444c"
		},
		"scene_colors": {
			"Muted": "#6f7988",
			"LightMuted": "#bab1b1",
			"DarkMuted": "#35465a"
		},
		"scene_name": "Early Morning At The Lake",
		"scene_id": "974d17b4-5848-45c2-8f15-f1d7dbd5a898"
	},
	{
		"clip_id": "fd578057-81db-44de-95ff-46662345dc09",
		"scene_lqip": "https://s3.amazonaws.com/storytape-prod-static/scene_3fc3c600-7d8c-4c7e-99b4-ac1d065a0234/lqip_491989d8-a2bb-4b41-9d05-b1d4d76a90a2.jpg",
		"scene_clip_count": "108",
		"published_at": "2017-11-07T21:00:00.457Z",
		"clip_sequence": [
			"https://s3.amazonaws.com/storytape-prod-static/fd578057-81db-44de-95ff-46662345dc09/sequence_272deedd-f4c9-4292-9648-cc9c7faaacfb/0000.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd578057-81db-44de-95ff-46662345dc09/sequence_272deedd-f4c9-4292-9648-cc9c7faaacfb/0001.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd578057-81db-44de-95ff-46662345dc09/sequence_272deedd-f4c9-4292-9648-cc9c7faaacfb/0002.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd578057-81db-44de-95ff-46662345dc09/sequence_272deedd-f4c9-4292-9648-cc9c7faaacfb/0003.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd578057-81db-44de-95ff-46662345dc09/sequence_272deedd-f4c9-4292-9648-cc9c7faaacfb/0004.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd578057-81db-44de-95ff-46662345dc09/sequence_272deedd-f4c9-4292-9648-cc9c7faaacfb/0005.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd578057-81db-44de-95ff-46662345dc09/sequence_272deedd-f4c9-4292-9648-cc9c7faaacfb/0006.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd578057-81db-44de-95ff-46662345dc09/sequence_272deedd-f4c9-4292-9648-cc9c7faaacfb/0007.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd578057-81db-44de-95ff-46662345dc09/sequence_272deedd-f4c9-4292-9648-cc9c7faaacfb/0008.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd578057-81db-44de-95ff-46662345dc09/sequence_272deedd-f4c9-4292-9648-cc9c7faaacfb/0009.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd578057-81db-44de-95ff-46662345dc09/sequence_272deedd-f4c9-4292-9648-cc9c7faaacfb/0010.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd578057-81db-44de-95ff-46662345dc09/sequence_272deedd-f4c9-4292-9648-cc9c7faaacfb/0011.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd578057-81db-44de-95ff-46662345dc09/sequence_272deedd-f4c9-4292-9648-cc9c7faaacfb/0012.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd578057-81db-44de-95ff-46662345dc09/sequence_272deedd-f4c9-4292-9648-cc9c7faaacfb/0013.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd578057-81db-44de-95ff-46662345dc09/sequence_272deedd-f4c9-4292-9648-cc9c7faaacfb/0014.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd578057-81db-44de-95ff-46662345dc09/sequence_272deedd-f4c9-4292-9648-cc9c7faaacfb/0015.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd578057-81db-44de-95ff-46662345dc09/sequence_272deedd-f4c9-4292-9648-cc9c7faaacfb/0016.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd578057-81db-44de-95ff-46662345dc09/sequence_272deedd-f4c9-4292-9648-cc9c7faaacfb/0017.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd578057-81db-44de-95ff-46662345dc09/sequence_272deedd-f4c9-4292-9648-cc9c7faaacfb/0018.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd578057-81db-44de-95ff-46662345dc09/sequence_272deedd-f4c9-4292-9648-cc9c7faaacfb/0019.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd578057-81db-44de-95ff-46662345dc09/sequence_272deedd-f4c9-4292-9648-cc9c7faaacfb/0020.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd578057-81db-44de-95ff-46662345dc09/sequence_272deedd-f4c9-4292-9648-cc9c7faaacfb/0021.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd578057-81db-44de-95ff-46662345dc09/sequence_272deedd-f4c9-4292-9648-cc9c7faaacfb/0022.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd578057-81db-44de-95ff-46662345dc09/sequence_272deedd-f4c9-4292-9648-cc9c7faaacfb/0023.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd578057-81db-44de-95ff-46662345dc09/sequence_272deedd-f4c9-4292-9648-cc9c7faaacfb/0024.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd578057-81db-44de-95ff-46662345dc09/sequence_272deedd-f4c9-4292-9648-cc9c7faaacfb/0025.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd578057-81db-44de-95ff-46662345dc09/sequence_272deedd-f4c9-4292-9648-cc9c7faaacfb/0026.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd578057-81db-44de-95ff-46662345dc09/sequence_272deedd-f4c9-4292-9648-cc9c7faaacfb/0027.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd578057-81db-44de-95ff-46662345dc09/sequence_272deedd-f4c9-4292-9648-cc9c7faaacfb/0028.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd578057-81db-44de-95ff-46662345dc09/sequence_272deedd-f4c9-4292-9648-cc9c7faaacfb/0029.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd578057-81db-44de-95ff-46662345dc09/sequence_272deedd-f4c9-4292-9648-cc9c7faaacfb/0030.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd578057-81db-44de-95ff-46662345dc09/sequence_272deedd-f4c9-4292-9648-cc9c7faaacfb/0031.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd578057-81db-44de-95ff-46662345dc09/sequence_272deedd-f4c9-4292-9648-cc9c7faaacfb/0032.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd578057-81db-44de-95ff-46662345dc09/sequence_272deedd-f4c9-4292-9648-cc9c7faaacfb/0033.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd578057-81db-44de-95ff-46662345dc09/sequence_272deedd-f4c9-4292-9648-cc9c7faaacfb/0034.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd578057-81db-44de-95ff-46662345dc09/sequence_272deedd-f4c9-4292-9648-cc9c7faaacfb/0035.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd578057-81db-44de-95ff-46662345dc09/sequence_272deedd-f4c9-4292-9648-cc9c7faaacfb/0036.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd578057-81db-44de-95ff-46662345dc09/sequence_272deedd-f4c9-4292-9648-cc9c7faaacfb/0037.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd578057-81db-44de-95ff-46662345dc09/sequence_272deedd-f4c9-4292-9648-cc9c7faaacfb/0038.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd578057-81db-44de-95ff-46662345dc09/sequence_272deedd-f4c9-4292-9648-cc9c7faaacfb/0039.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd578057-81db-44de-95ff-46662345dc09/sequence_272deedd-f4c9-4292-9648-cc9c7faaacfb/0040.png"
		],
		"keywords": [
			"alluring",
			"ash",
			"attractive",
			"backdrop",
			"background",
			"basic",
			"beautiful",
			"black",
			"bonfire",
			"bright",
			"burn",
			"burnt",
			"captivating",
			"compelling",
			"concept",
			"danger",
			"distinctive",
			"embers",
			"energy",
			"fiery",
			"fire",
			"fire embers",
			"fireplace",
			"flame",
			"flaming",
			"flying",
			"glow",
			"glowing",
			"heat",
			"hell",
			"hot",
			"isolated",
			"light",
			"night",
			"power",
			"simple",
			"spark",
			"striking",
			"stylish",
			"texture"
		],
		"clip_slug": "feathers-melt-into-droplets-under-white-flames",
		"clip_poster": "https://s3.amazonaws.com/storytape-prod-static/fd578057-81db-44de-95ff-46662345dc09/poster_0000_631c248d-293a-45e6-8272-79e9d8abca22.png",
		"clip_preview_large": "https://s3.amazonaws.com/storytape-prod-static/fd578057-81db-44de-95ff-46662345dc09/preview-large-b9413c15-0f54-4b0a-a085-db0d801f69a3.mp4",
		"clip_length": 20000,
		"scene_description": "Pyrotechnics can be dangerous - so why not leave it behind a screen? Hot red fire burn various materials as bright flames flicker into the dark in a mesmerizing fashion.",
		"clip_thumbnail": "https://s3.amazonaws.com/storytape-prod-static/fd578057-81db-44de-95ff-46662345dc09/thumbnail_0000_eb972bf0-b7cd-41c3-88a8-51f23d90c06b.png",
		"clip_name": "Feathers melt into droplets under white flames",
		"scene_thumbnail": "https://s3.amazonaws.com/storytape-prod-static/scene_3fc3c600-7d8c-4c7e-99b4-ac1d065a0234/thumbnail_cb3e56d8-5630-465e-bde7-87bbcd3b2f3d.jpg",
		"clip_preview_small": "https://s3.amazonaws.com/storytape-prod-static/fd578057-81db-44de-95ff-46662345dc09/preview-small-189d61bf-63d4-4e4d-b09d-7a1e06ccc580.mp4",
		"tags": [
			4400,
			2600,
			4100,
			2300,
			2200,
			3800,
			100
		],
		"featured_at": "2017-11-14T07:07:50.396Z",
		"clip_lqip": "https://s3.amazonaws.com/storytape-prod-static/scene_fd578057-81db-44de-95ff-46662345dc09/lqip_92c29451-62e4-4d1a-81b6-a99d1df6ade9.jpg",
		"scene_poster": "https://s3.amazonaws.com/storytape-prod-static/scene_3fc3c600-7d8c-4c7e-99b4-ac1d065a0234/poster_8bb5555f-f276-4d7a-af6e-1aca6972a404.jpg",
		"scene_slug": "flames-and-embers",
		"clip_colors": {
			"DarkMuted": "#0c0c0c"
		},
		"scene_colors": {
			"Vibrant": "#fb731b",
			"LightVibrant": "#fce28d",
			"DarkVibrant": "#bd2404",
			"DarkMuted": "#080404"
		},
		"scene_name": "Flames And Embers",
		"scene_id": "3fc3c600-7d8c-4c7e-99b4-ac1d065a0234"
	},
	{
		"clip_id": "f8e9ce10-fa2b-46b0-864b-d13232566dfd",
		"scene_lqip": "https://s3.amazonaws.com/storytape-prod-static/scene_54bb3628-65f3-49e6-9f49-e7837d179887/lqip_57c04113-8fc7-4ec1-965e-4964d677b8c6.jpg",
		"scene_clip_count": "33",
		"published_at": "2017-10-25T19:28:26.067Z",
		"clip_sequence": [
			"https://s3.amazonaws.com/storytape-prod-static/f8e9ce10-fa2b-46b0-864b-d13232566dfd/sequence_37774c3f-e23b-42be-935b-9c11935a0e82/0000.png",
			"https://s3.amazonaws.com/storytape-prod-static/f8e9ce10-fa2b-46b0-864b-d13232566dfd/sequence_37774c3f-e23b-42be-935b-9c11935a0e82/0001.png",
			"https://s3.amazonaws.com/storytape-prod-static/f8e9ce10-fa2b-46b0-864b-d13232566dfd/sequence_37774c3f-e23b-42be-935b-9c11935a0e82/0002.png",
			"https://s3.amazonaws.com/storytape-prod-static/f8e9ce10-fa2b-46b0-864b-d13232566dfd/sequence_37774c3f-e23b-42be-935b-9c11935a0e82/0003.png",
			"https://s3.amazonaws.com/storytape-prod-static/f8e9ce10-fa2b-46b0-864b-d13232566dfd/sequence_37774c3f-e23b-42be-935b-9c11935a0e82/0004.png",
			"https://s3.amazonaws.com/storytape-prod-static/f8e9ce10-fa2b-46b0-864b-d13232566dfd/sequence_37774c3f-e23b-42be-935b-9c11935a0e82/0005.png",
			"https://s3.amazonaws.com/storytape-prod-static/f8e9ce10-fa2b-46b0-864b-d13232566dfd/sequence_37774c3f-e23b-42be-935b-9c11935a0e82/0006.png",
			"https://s3.amazonaws.com/storytape-prod-static/f8e9ce10-fa2b-46b0-864b-d13232566dfd/sequence_37774c3f-e23b-42be-935b-9c11935a0e82/0007.png",
			"https://s3.amazonaws.com/storytape-prod-static/f8e9ce10-fa2b-46b0-864b-d13232566dfd/sequence_37774c3f-e23b-42be-935b-9c11935a0e82/0008.png",
			"https://s3.amazonaws.com/storytape-prod-static/f8e9ce10-fa2b-46b0-864b-d13232566dfd/sequence_37774c3f-e23b-42be-935b-9c11935a0e82/0009.png",
			"https://s3.amazonaws.com/storytape-prod-static/f8e9ce10-fa2b-46b0-864b-d13232566dfd/sequence_37774c3f-e23b-42be-935b-9c11935a0e82/0010.png",
			"https://s3.amazonaws.com/storytape-prod-static/f8e9ce10-fa2b-46b0-864b-d13232566dfd/sequence_37774c3f-e23b-42be-935b-9c11935a0e82/0011.png",
			"https://s3.amazonaws.com/storytape-prod-static/f8e9ce10-fa2b-46b0-864b-d13232566dfd/sequence_37774c3f-e23b-42be-935b-9c11935a0e82/0012.png",
			"https://s3.amazonaws.com/storytape-prod-static/f8e9ce10-fa2b-46b0-864b-d13232566dfd/sequence_37774c3f-e23b-42be-935b-9c11935a0e82/0013.png",
			"https://s3.amazonaws.com/storytape-prod-static/f8e9ce10-fa2b-46b0-864b-d13232566dfd/sequence_37774c3f-e23b-42be-935b-9c11935a0e82/0014.png",
			"https://s3.amazonaws.com/storytape-prod-static/f8e9ce10-fa2b-46b0-864b-d13232566dfd/sequence_37774c3f-e23b-42be-935b-9c11935a0e82/0015.png",
			"https://s3.amazonaws.com/storytape-prod-static/f8e9ce10-fa2b-46b0-864b-d13232566dfd/sequence_37774c3f-e23b-42be-935b-9c11935a0e82/0016.png",
			"https://s3.amazonaws.com/storytape-prod-static/f8e9ce10-fa2b-46b0-864b-d13232566dfd/sequence_37774c3f-e23b-42be-935b-9c11935a0e82/0017.png",
			"https://s3.amazonaws.com/storytape-prod-static/f8e9ce10-fa2b-46b0-864b-d13232566dfd/sequence_37774c3f-e23b-42be-935b-9c11935a0e82/0018.png",
			"https://s3.amazonaws.com/storytape-prod-static/f8e9ce10-fa2b-46b0-864b-d13232566dfd/sequence_37774c3f-e23b-42be-935b-9c11935a0e82/0019.png",
			"https://s3.amazonaws.com/storytape-prod-static/f8e9ce10-fa2b-46b0-864b-d13232566dfd/sequence_37774c3f-e23b-42be-935b-9c11935a0e82/0020.png",
			"https://s3.amazonaws.com/storytape-prod-static/f8e9ce10-fa2b-46b0-864b-d13232566dfd/sequence_37774c3f-e23b-42be-935b-9c11935a0e82/0021.png",
			"https://s3.amazonaws.com/storytape-prod-static/f8e9ce10-fa2b-46b0-864b-d13232566dfd/sequence_37774c3f-e23b-42be-935b-9c11935a0e82/0022.png",
			"https://s3.amazonaws.com/storytape-prod-static/f8e9ce10-fa2b-46b0-864b-d13232566dfd/sequence_37774c3f-e23b-42be-935b-9c11935a0e82/0023.png",
			"https://s3.amazonaws.com/storytape-prod-static/f8e9ce10-fa2b-46b0-864b-d13232566dfd/sequence_37774c3f-e23b-42be-935b-9c11935a0e82/0024.png",
			"https://s3.amazonaws.com/storytape-prod-static/f8e9ce10-fa2b-46b0-864b-d13232566dfd/sequence_37774c3f-e23b-42be-935b-9c11935a0e82/0025.png",
			"https://s3.amazonaws.com/storytape-prod-static/f8e9ce10-fa2b-46b0-864b-d13232566dfd/sequence_37774c3f-e23b-42be-935b-9c11935a0e82/0026.png",
			"https://s3.amazonaws.com/storytape-prod-static/f8e9ce10-fa2b-46b0-864b-d13232566dfd/sequence_37774c3f-e23b-42be-935b-9c11935a0e82/0027.png",
			"https://s3.amazonaws.com/storytape-prod-static/f8e9ce10-fa2b-46b0-864b-d13232566dfd/sequence_37774c3f-e23b-42be-935b-9c11935a0e82/0028.png",
			"https://s3.amazonaws.com/storytape-prod-static/f8e9ce10-fa2b-46b0-864b-d13232566dfd/sequence_37774c3f-e23b-42be-935b-9c11935a0e82/0029.png",
			"https://s3.amazonaws.com/storytape-prod-static/f8e9ce10-fa2b-46b0-864b-d13232566dfd/sequence_37774c3f-e23b-42be-935b-9c11935a0e82/0030.png",
			"https://s3.amazonaws.com/storytape-prod-static/f8e9ce10-fa2b-46b0-864b-d13232566dfd/sequence_37774c3f-e23b-42be-935b-9c11935a0e82/0031.png",
			"https://s3.amazonaws.com/storytape-prod-static/f8e9ce10-fa2b-46b0-864b-d13232566dfd/sequence_37774c3f-e23b-42be-935b-9c11935a0e82/0032.png",
			"https://s3.amazonaws.com/storytape-prod-static/f8e9ce10-fa2b-46b0-864b-d13232566dfd/sequence_37774c3f-e23b-42be-935b-9c11935a0e82/0033.png",
			"https://s3.amazonaws.com/storytape-prod-static/f8e9ce10-fa2b-46b0-864b-d13232566dfd/sequence_37774c3f-e23b-42be-935b-9c11935a0e82/0034.png",
			"https://s3.amazonaws.com/storytape-prod-static/f8e9ce10-fa2b-46b0-864b-d13232566dfd/sequence_37774c3f-e23b-42be-935b-9c11935a0e82/0035.png",
			"https://s3.amazonaws.com/storytape-prod-static/f8e9ce10-fa2b-46b0-864b-d13232566dfd/sequence_37774c3f-e23b-42be-935b-9c11935a0e82/0036.png",
			"https://s3.amazonaws.com/storytape-prod-static/f8e9ce10-fa2b-46b0-864b-d13232566dfd/sequence_37774c3f-e23b-42be-935b-9c11935a0e82/0037.png"
		],
		"keywords": [
			"adventure",
			"aerial",
			"beautiful",
			"ecology",
			"environment",
			"high",
			"hill",
			"horizon",
			"iceland",
			"landscape",
			"majestic",
			"mountains",
			"nature",
			"nobody",
			"outdoor",
			"peak",
			"range",
			"ridge",
			"river",
			"rocks",
			"scene",
			"scenery",
			"scenic",
			"stream",
			"summit",
			"sun",
			"sunrise",
			"sunset",
			"tourism",
			"travel",
			"view",
			"water",
			"wild",
			"wilderness"
		],
		"clip_slug": "majestic-snow-capped-mountain-range",
		"clip_poster": "https://s3.amazonaws.com/storytape-prod-static/f8e9ce10-fa2b-46b0-864b-d13232566dfd/poster_0000_a505ed5a-cc8e-4670-bc50-0ac24ca11d7a.png",
		"clip_preview_large": "https://s3.amazonaws.com/storytape-prod-static/f8e9ce10-fa2b-46b0-864b-d13232566dfd/preview-large-a2192c68-6890-4856-99f0-81c87e583a32.mp4",
		"clip_length": 18625,
		"scene_description": "Under the sunset light, a river splits into a thousand separate channels in a valley between mountain ranges. As the sun goes down, the green grass gets lost in the dark shadows, while the sun glistens on the water below.",
		"clip_thumbnail": "https://s3.amazonaws.com/storytape-prod-static/f8e9ce10-fa2b-46b0-864b-d13232566dfd/thumbnail_0000_65b41095-3cb9-401f-a488-c9438cf236c5.png",
		"clip_name": "Majestic snow-capped mountain range",
		"scene_thumbnail": "https://s3.amazonaws.com/storytape-prod-static/scene_54bb3628-65f3-49e6-9f49-e7837d179887/thumbnail_e4d1c679-90b0-43f7-afd3-371b439d2d70.jpg",
		"clip_preview_small": "https://s3.amazonaws.com/storytape-prod-static/f8e9ce10-fa2b-46b0-864b-d13232566dfd/preview-small-0a28f524-3f97-45da-851b-bb3b01330e7b.mp4",
		"tags": [
			1100,
			2700,
			4300,
			4200,
			900,
			2300,
			2100,
			3000,
			3600,
			200,
			3400
		],
		"featured_at": "2017-11-14T07:07:26.814Z",
		"clip_lqip": "https://s3.amazonaws.com/storytape-prod-static/scene_f8e9ce10-fa2b-46b0-864b-d13232566dfd/lqip_960aa0ea-fe14-46d5-88f0-9c752bf42f31.jpg",
		"scene_poster": "https://s3.amazonaws.com/storytape-prod-static/scene_54bb3628-65f3-49e6-9f49-e7837d179887/poster_151323f3-978a-477c-b517-5e0730f964cd.jpg",
		"scene_slug": "rivers-and-mountains",
		"clip_colors": {
			"Vibrant": "#b28a4c",
			"DarkVibrant": "#544124",
			"Muted": "#676471",
			"LightMuted": "#acb3c3",
			"DarkMuted": "#443b44"
		},
		"scene_colors": {
			"Vibrant": "#ad6851",
			"LightVibrant": "#f4ecdc",
			"DarkVibrant": "#3c241c",
			"Muted": "#947c5c",
			"LightMuted": "#d5cabf",
			"DarkMuted": "#5e4c34"
		},
		"scene_name": "Rivers And Mountains",
		"scene_id": "54bb3628-65f3-49e6-9f49-e7837d179887"
	},
	{
		"clip_id": "fd87184f-e985-4630-a073-7a02f2c89834",
		"scene_lqip": "https://s3.amazonaws.com/storytape-prod-static/scene_6d6b5477-65b5-498a-81e7-f0de3772f87f/lqip_2adaff57-e756-4e3a-a43c-6c04bf0e8abc.jpg",
		"scene_clip_count": "61",
		"published_at": "2017-10-30T19:02:50.178Z",
		"clip_sequence": [
			"https://s3.amazonaws.com/storytape-prod-static/fd87184f-e985-4630-a073-7a02f2c89834/sequence_c33477bc-b32c-4ff5-9697-6f86e948e008/0000.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd87184f-e985-4630-a073-7a02f2c89834/sequence_c33477bc-b32c-4ff5-9697-6f86e948e008/0001.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd87184f-e985-4630-a073-7a02f2c89834/sequence_c33477bc-b32c-4ff5-9697-6f86e948e008/0002.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd87184f-e985-4630-a073-7a02f2c89834/sequence_c33477bc-b32c-4ff5-9697-6f86e948e008/0003.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd87184f-e985-4630-a073-7a02f2c89834/sequence_c33477bc-b32c-4ff5-9697-6f86e948e008/0004.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd87184f-e985-4630-a073-7a02f2c89834/sequence_c33477bc-b32c-4ff5-9697-6f86e948e008/0005.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd87184f-e985-4630-a073-7a02f2c89834/sequence_c33477bc-b32c-4ff5-9697-6f86e948e008/0006.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd87184f-e985-4630-a073-7a02f2c89834/sequence_c33477bc-b32c-4ff5-9697-6f86e948e008/0007.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd87184f-e985-4630-a073-7a02f2c89834/sequence_c33477bc-b32c-4ff5-9697-6f86e948e008/0008.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd87184f-e985-4630-a073-7a02f2c89834/sequence_c33477bc-b32c-4ff5-9697-6f86e948e008/0009.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd87184f-e985-4630-a073-7a02f2c89834/sequence_c33477bc-b32c-4ff5-9697-6f86e948e008/0010.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd87184f-e985-4630-a073-7a02f2c89834/sequence_c33477bc-b32c-4ff5-9697-6f86e948e008/0011.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd87184f-e985-4630-a073-7a02f2c89834/sequence_c33477bc-b32c-4ff5-9697-6f86e948e008/0012.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd87184f-e985-4630-a073-7a02f2c89834/sequence_c33477bc-b32c-4ff5-9697-6f86e948e008/0013.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd87184f-e985-4630-a073-7a02f2c89834/sequence_c33477bc-b32c-4ff5-9697-6f86e948e008/0014.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd87184f-e985-4630-a073-7a02f2c89834/sequence_c33477bc-b32c-4ff5-9697-6f86e948e008/0015.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd87184f-e985-4630-a073-7a02f2c89834/sequence_c33477bc-b32c-4ff5-9697-6f86e948e008/0016.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd87184f-e985-4630-a073-7a02f2c89834/sequence_c33477bc-b32c-4ff5-9697-6f86e948e008/0017.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd87184f-e985-4630-a073-7a02f2c89834/sequence_c33477bc-b32c-4ff5-9697-6f86e948e008/0018.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd87184f-e985-4630-a073-7a02f2c89834/sequence_c33477bc-b32c-4ff5-9697-6f86e948e008/0019.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd87184f-e985-4630-a073-7a02f2c89834/sequence_c33477bc-b32c-4ff5-9697-6f86e948e008/0020.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd87184f-e985-4630-a073-7a02f2c89834/sequence_c33477bc-b32c-4ff5-9697-6f86e948e008/0021.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd87184f-e985-4630-a073-7a02f2c89834/sequence_c33477bc-b32c-4ff5-9697-6f86e948e008/0022.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd87184f-e985-4630-a073-7a02f2c89834/sequence_c33477bc-b32c-4ff5-9697-6f86e948e008/0023.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd87184f-e985-4630-a073-7a02f2c89834/sequence_c33477bc-b32c-4ff5-9697-6f86e948e008/0024.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd87184f-e985-4630-a073-7a02f2c89834/sequence_c33477bc-b32c-4ff5-9697-6f86e948e008/0025.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd87184f-e985-4630-a073-7a02f2c89834/sequence_c33477bc-b32c-4ff5-9697-6f86e948e008/0026.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd87184f-e985-4630-a073-7a02f2c89834/sequence_c33477bc-b32c-4ff5-9697-6f86e948e008/0027.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd87184f-e985-4630-a073-7a02f2c89834/sequence_c33477bc-b32c-4ff5-9697-6f86e948e008/0028.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd87184f-e985-4630-a073-7a02f2c89834/sequence_c33477bc-b32c-4ff5-9697-6f86e948e008/0029.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd87184f-e985-4630-a073-7a02f2c89834/sequence_c33477bc-b32c-4ff5-9697-6f86e948e008/0030.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd87184f-e985-4630-a073-7a02f2c89834/sequence_c33477bc-b32c-4ff5-9697-6f86e948e008/0031.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd87184f-e985-4630-a073-7a02f2c89834/sequence_c33477bc-b32c-4ff5-9697-6f86e948e008/0032.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd87184f-e985-4630-a073-7a02f2c89834/sequence_c33477bc-b32c-4ff5-9697-6f86e948e008/0033.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd87184f-e985-4630-a073-7a02f2c89834/sequence_c33477bc-b32c-4ff5-9697-6f86e948e008/0034.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd87184f-e985-4630-a073-7a02f2c89834/sequence_c33477bc-b32c-4ff5-9697-6f86e948e008/0035.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd87184f-e985-4630-a073-7a02f2c89834/sequence_c33477bc-b32c-4ff5-9697-6f86e948e008/0036.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd87184f-e985-4630-a073-7a02f2c89834/sequence_c33477bc-b32c-4ff5-9697-6f86e948e008/0037.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd87184f-e985-4630-a073-7a02f2c89834/sequence_c33477bc-b32c-4ff5-9697-6f86e948e008/0038.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd87184f-e985-4630-a073-7a02f2c89834/sequence_c33477bc-b32c-4ff5-9697-6f86e948e008/0039.png"
		],
		"keywords": [
			"Europe",
			"Ireland",
			"Irish",
			"autumn",
			"bay",
			"boat",
			"buildings",
			"calm",
			"coast",
			"coastal",
			"community",
			"dawn",
			"drone",
			"early",
			"fall",
			"harbor",
			"harbour",
			"houses",
			"inlet",
			"morning",
			"ocean",
			"peaceful",
			"quaint",
			"quiet",
			"sail",
			"sea",
			"seaside",
			"sunrise",
			"town",
			"vessel",
			"village",
			"water"
		],
		"clip_slug": "algae-patches-float-on-harbor-water",
		"clip_poster": "https://s3.amazonaws.com/storytape-prod-static/fd87184f-e985-4630-a073-7a02f2c89834/poster_0000_686c3488-87cd-4d09-8762-0dfe8c0b01c3.png",
		"clip_preview_large": "https://s3.amazonaws.com/storytape-prod-static/fd87184f-e985-4630-a073-7a02f2c89834/preview-large-4fd5839d-1c02-4503-a812-ffaf4a20e8ea.mp4",
		"clip_length": 19917,
		"scene_description": "An early morning in an Irish seaside town. The slow rising sun gives light to the still sailboats in the quiet harbor and quaint community below.",
		"clip_thumbnail": "https://s3.amazonaws.com/storytape-prod-static/fd87184f-e985-4630-a073-7a02f2c89834/thumbnail_0000_2e223917-9a1e-473a-a9dd-ee3a96814fb3.png",
		"clip_name": "Algae patches float on harbor water",
		"scene_thumbnail": "https://s3.amazonaws.com/storytape-prod-static/scene_6d6b5477-65b5-498a-81e7-f0de3772f87f/thumbnail_431287c8-6e54-431d-b250-02b7cb832367.jpg",
		"clip_preview_small": "https://s3.amazonaws.com/storytape-prod-static/fd87184f-e985-4630-a073-7a02f2c89834/preview-small-fa648597-ea6c-40f5-84e2-577c0651ae34.mp4",
		"tags": [
			4400,
			2700,
			4200,
			900,
			2300,
			500,
			2100,
			3000,
			3600,
			200,
			3200
		],
		"featured_at": "2017-11-14T07:06:54.945Z",
		"clip_lqip": "https://s3.amazonaws.com/storytape-prod-static/scene_fd87184f-e985-4630-a073-7a02f2c89834/lqip_2aee7f4b-d9ab-4a14-8c12-0893998bc373.jpg",
		"scene_poster": "https://s3.amazonaws.com/storytape-prod-static/scene_6d6b5477-65b5-498a-81e7-f0de3772f87f/poster_24954ecc-c2df-499a-ab5d-48789264ee8c.jpg",
		"scene_slug": "seaside-harbor-town-at-sunrise",
		"clip_colors": {
			"Vibrant": "#4797b7",
			"DarkVibrant": "#244c5c",
			"Muted": "#73747c",
			"LightMuted": "#c4cbd0",
			"DarkMuted": "#463f3b"
		},
		"scene_colors": {
			"Vibrant": "#bc946e",
			"LightVibrant": "#f4e4c4",
			"DarkVibrant": "#553c24",
			"Muted": "#847f7d",
			"LightMuted": "#c3b3a5",
			"DarkMuted": "#41352e"
		},
		"scene_name": "Seaside Harbor Town At Sunrise",
		"scene_id": "6d6b5477-65b5-498a-81e7-f0de3772f87f"
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/assets/homepage_scenes.json
// module id = 1284
// module chunks = 1